import { useEffect, useState } from "react";
import NavigationBar from "../NavigationBar/NavigationBarComponent";
import styles from "./SubSystemConfiguration.module.css";
import { Button, InputLabel, MenuItem, TextField, Tooltip, Typography } from "@mui/material";
import AddBoxIcon from '@mui/icons-material/AddBox';
import { Form, Col, Row } from "react-bootstrap";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CloseIcon from '@mui/icons-material/Close';
import { DialogProps } from "../../types/SimpleSearchModel";
import ConfirmationDialog from "../SimpleSearch/ConfirmationDialog";
import { DecryptPassword, GetAccountByUser, GetActiveFileLocation, GetFolders, GetMetadataColumns } from "../../api/commonApi";
import { useLoader } from "../../context/LoaderContext";
import { CreateSubSystemConfiguration, DeleteProfileName, GetSubSystemConfiguration, RemoveSubsystemdata } from "../../api/subSystemConfiurationApi/subSystemConfigurationApi";
import { AgGridReact } from "ag-grid-react";
import { ColDef } from "ag-grid-enterprise";
import { getFieldData } from "../../api/listSearchAPI/listSearchApi";
import { ListFieldModel } from "../../types/ListFieldModel";
import { useSnackbar } from "../Common/SnackbarContext";
import PermDeviceInformationRoundedIcon from "@mui/icons-material/PermDeviceInformationRounded";
import LocalStorageUtil from "../../utils/localStorage";

interface Option {
    value: number;
    label: string;
}

interface Category {
    label: string;
    options: Option[];
}

const SubSystemConfiguration = () => {
    const { showSnackbar } = useSnackbar();
    const { setLoading } = useLoader();
    const [steps, setSteps] = useState([
        { key: 'firstStep', label: 'Basic Information', isDone: true }
    ]);
    const [reload,] = useState(false); // State variable to trigger re-render
    const [errorProfileKey, setErrorProfileKey] = useState<string>('');
    const [subSystemData, setSubSystemData] = useState<any[]>([]);
    const [level, setLevel] = useState<any[]>([]);
    const [profileName, setProfileName] = useState<string>('');
    const [inputGroups, setInputGroups] = useState<any[]>([{ subSystemName: '' }]);
    const [selectedAccountName, setSelectedAccountName] = useState<string>();
    const [accountId, setAccountId] = useState<number>(1);
    const operator = [
        {
            value: "Equals",
            label: "Exactly Matches =",
        },
        {
            value: "NotEqualString",
            label: "Does Not Contain",
        },
        {
            value: "StartsWith",
            label: "Begins with",
        },
        {
            value: "EndsWith",
            label: "Ends with",
        },
        {
            value: "Contains",
            label: "Contains",
        },
        {
            value: "IN",
            label: "IN",
        }
    ];

    const andOr = [
        {
            value: "AND",
            label: "AND",
        },
        {
            value: "OR",
            label: "OR",
        }
    ];
    const inputSourceTypes = [
        {
            id: 1, name: 'PDF'
        },
        {
            id: 2, name: 'Metadata'
        },
        {
            id: 3, name: 'PDF + Metadata'
        },
        {
            id: 4, name: 'PPDF'
        },
        {
            id: 5, name: 'Zip(PDF)'
        },
        {
            id: 6, name: 'Zip(PDF + Metadata)'
        }
    ];
    const outputSourceTypes = [
        {
            id: 1, name: 'PDF'
        },
        {
            id: 2, name: 'Metadata'
        },
        {
            id: 3, name: 'PDF + Metadata'
        }
    ];
    const [activeStep, setActiveStep] = useState(steps[0]);
    const [dialogProps, setDialogProps] = useState<DialogProps>({
        dialogTitle: "",
        contentText: "",
        confirmText: "",
        closeText: "",
        onConfirm: null,
    });
    const [dialogOpen, setDialogOpen] = useState(false);
    const [accountName, setAccountName] = useState<any[]>([]);
    const [accountNameId, setAccountNameId] = useState<number>();
    const [nextStep, setNextStep] = useState(0);
    const [categories, setCategories] = useState<Category[]>([]);
    const [activeFileLocations, setActiveFileLocations] = useState<any[]>([]);
    const [metadataColumns, setMetadataColumns] = useState<any[]>([]);
    const [subAllSystemConfig, SetSubAllSystemConfig] = useState<any[]>([{
        subSystemConfigurationId: 1,
        isPdfSelected: false,
        isMetadataSelected: false,
        isOutputPdfSelected: false,
        isOutputMetadataSelected: false,
        subSystemName: '',
        searchCriterias:
            [{
                metadataFieldName: '',
                fieldMappingId: null,
                logicalOperator: '',
                operator: '',
                value1: '',
                value2: '',
                subSystemSearchCriteriaID: null,
                subsytemConfigurationId: null,
                fieldName: '',
                fieldItem: {
                    metaDataFieldId: null,
                    field: "",
                    customField: "",
                    categoryName: "",
                    fieldMappingId: null,
                },
                errorFieldMappingId: '',
                errorLogicalOperator: '',
                errorOperator: '',
                errorValue1: '',
            }],
        accountSubSystemProfileKey: [],
        subSystemModelobj: [{
            errorToLocationType: '',
            toPdfLocationId: null,
            toMetadataLocationId: null,
            fromType: null,
            tolocationType: null,
            fromLocationId: null,
            fromMetaDataLocationId: null,
            subSystemId: null,
            subSystemConfigurationId: null,
            fromSourceMetadataDefinitionId: null,
            toSourceMetadataDefinitionId: null,
            isFromSourceHeaderAvailable: 1,
            isToSourceHeaderAvailable: 2,
            aPI_SMB: 1,
            aPIURL: "",
            aPIUserName: "",
            password: "",
            aPICallbackUrl: "",
            pdfNamingConvention: "",
            fromLevel1: null,
            metadataNamingConvention: "",
            preflightErroremail: "",
            isAllowReprocess: false,
            frequencyHrs: null,
            frequencyMins: null,
            aPICallback_UserName: "",
            aPICallbackPassword: "",
            exportOption: 1,
            errorUserId: '',
            errorPassword: '',
            errorUrl: '',
            errorApiallBackUserId: '',
            errorApiallBackPassword: '',
            errorApiallBackUrl: '',
            isImportActive: false,
            isExportActive: false,
            importEmailTemplateTypeId: null,
            exportEmailTemplateTypeId: null,
            accountSubSystemEmailConfigurationId: null,
            createdBy: null,
        }]
    }]);// NOSONAR
    useEffect(() => {
        getAccountName();
    }, [reload]);

    const getAccountName = async () => {
        setLoading(true);
        const payload: any = {
            userId: Number(LocalStorageUtil.getItem("userId")),
        };
        // istanbul ignore next
        try {
            const accountNameData = await GetAccountByUser(payload);
            setAccountName(accountNameData);
        } catch (error) {
            showSnackbar("Error fetching data", true);
        } finally {
            setLoading(false);
        }
    };
    const handleAddInputGroup = (index: number) => {
        if (inputGroups[index].subSystemName === '') {
            showSnackbar("Please enter Source Name", true);
        } else {
        const newInputGroups = [...inputGroups];
        newInputGroups[0] = { subSystemName: '' }; // Mark the first item as empty
        newInputGroups.push({ subSystemName: inputGroups[index].subSystemName }); // Add new item at the end
        setInputGroups(newInputGroups);
        }
    }
    const handleDeleteSource = (index: number, key: string) => {
        setDialogProps({
            dialogTitle: "Delete Confirmation",
            contentText: "Are you sure you want to delete the Subsystem Configuration ?",
            confirmText: "Yes",
            closeText: "No",
            onConfirm: async () => await handleDeleteInputGroup(index, key),
        });
        setDialogOpen(true);
    }

    const handleDeleteInputGroup = async (index: number, key: string): Promise<void> => {
        const newInputGroups = inputGroups.filter((_, i) => i !== index);
        const newSteps = steps.filter(step => step.key !== key);
        const data = subSystemData.find((item: any) => item.stageName === key);
        if(data !== undefined) {
            let searchCriterias: any[] = [];
            data.subSytemSearchCriteriaobj.forEach((element: any) => {
                searchCriterias.push({
                    subsytemConfigurationId: data.subSystemConfigurationId,
                    subSystemSearchCriteriaID: element.subSystemSearchCriteriaID,
                    field: element.field,
                    operator: element.operator,
                    logicalOperator: element.logicalOperator,
                    value1: element.value1,
                    value2: element.value2,
                    fieldName: element.fieldName,
                    metadataFieldName: element.metadataFieldName,
                    fieldMappingId: element.fieldMappingId,
                    metaDataFieldId: element.metaDataFieldId,                
                });
            });
            const payload = {
                SearchCriterias: [searchCriterias],
                contextName: selectedAccountName,
                DeletedSubSystemConfigurationId: [data.subSystemConfigurationId]
            }
            await RemoveSubsystemdata(payload);
            showSnackbar("SubSystem Removed Successfully");
        }
        const newSubSystemData = subSystemData.filter((item: any) => item.stageName !== key);
        setSubSystemData(newSubSystemData);
        setInputGroups(newInputGroups);
        setSteps(newSteps);
        setDialogOpen(false);
    };
    const handleSearchChange = (index: number, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newInputGroups = [...inputGroups];
        newInputGroups[index].subSystemName = event.target.value;
        setInputGroups(newInputGroups);
    };
    const handleCustomerNameChange = (
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        setAccountNameId(Number(event.target.value));
        const newContextName = accountName.find((option) => option.businessUnitId === Number(event.target.value))?.contextName;
        setSelectedAccountName(newContextName);
        getSubSystemName(Number(event.target.value), newContextName);
        getActiveFileLocation(Number(event.target.value), newContextName);
        getMetadataColumns(Number(event.target.value), newContextName);
        setInputGroups([{ subSystemName: '' }]);
    }
    const getSubSystemName = async (accountNameId: number, accountName: string) => {
        setLoading(true);
        SetSubAllSystemConfig([{
            subSystemConfigurationId: 1,
            isPdfSelected: false,
            isMetadataSelected: false,
            isOutputPdfSelected: false,
            isOutputMetadataSelected: false,
            subSystemName: '',
            searchCriterias:
                [{
                    metadataFieldName: '',
                    fieldMappingId: null,
                    logicalOperator: '',
                    operator: '',
                    value1: '',
                    value2: '',
                    subSystemSearchCriteriaID: null,
                    subsytemConfigurationId: null,
                    fieldName: '',
                    fieldItem: {
                        metaDataFieldId: null,
                        field: "",
                        customField: "",
                        categoryName: "",
                        fieldMappingId: null,
                    },
                    errorFieldMappingId: '',
                    errorLogicalOperator: '',
                    errorOperator: '',
                    errorValue1: '',
                }],
            accountSubSystemProfileKey: [],
            subSystemModelobj: [{
                errorToLocationType: '',
                toPdfLocationId: null,
                toMetadataLocationId: null,
                fromType: null,
                tolocationType: null,
                fromLocationId: null,
                fromMetaDataLocationId: null,
                subSystemId: null,
                subSystemConfigurationId: null,
                fromSourceMetadataDefinitionId: null,
                toSourceMetadataDefinitionId: null,
                isFromSourceHeaderAvailable: 1,
                isToSourceHeaderAvailable: 2,
                aPI_SMB: 1,
                aPIURL: "",
                aPIUserName: "",
                password: "",
                aPICallbackUrl: "",
                pdfNamingConvention: "",
                fromLevel1: null,
                metadataNamingConvention: "",
                preflightErroremail: "",
                isAllowReprocess: false,
                frequencyHrs: null,
                frequencyMins: null,
                aPICallback_UserName: "",
                aPICallbackPassword: "",
                exportOption: 1,
                errorUserId: '',
                errorPassword: '',
                errorUrl: '',
                errorApiallBackUserId: '',
                errorApiallBackPassword: '',
                errorApiallBackUrl: '',
                isImportActive: false,
                isExportActive: false,
                importEmailTemplateTypeId: null,
                exportEmailTemplateTypeId: null,
                accountSubSystemEmailConfigurationId: null,
                createdBy: null,
            }]
        }]);
        setInputGroups([{ subSystemName: '' }]);
        setSteps([
            { key: 'firstStep', label: 'Basic Information', isDone: true }
        ]);
        setSubSystemData([]);
        const payload: any = {
            businessUnitId: Number(accountNameId),
            contextName: accountName,
        };
        try {
            const response = await GetSubSystemConfiguration(payload);
            if (response.length > 0) {
                setAccountId(response[0].subSystemModelobj[0].accountId);
                const newInputGroups = response.map((source: any) => {
                    return { subSystemName: source.subSystemName };
                });
                // Prepend an object with an empty sourceName value
                newInputGroups.unshift({ subSystemName: '' });
                setInputGroups(newInputGroups);
                setSubSystemData(response);
            }
        } catch (error) {
            showSnackbar("Error fetching data", true);
        } finally {
            setLoading(false);
        }
    };

    const validateSubmitQuery = (element: any): boolean => {
        let isError = [];

        if (element.aPI_SMB === 2) {
            if (element.tolocationType === '' || element.tolocationType === '0' || element.tolocationType === null) {
                element.errorToLocationType = "Please select the Input Option";
                isError.push(true);
            } else {
                element.errorToLocationType = "";
                isError.push(false);
            }
        }
        if (element.aPI_SMB === 1) {
            if (element.aPIUserName === '' || element.aPIUserName === null) {
                element.errorUserId = "Please enter the User Name";
                isError.push(true);
            } else {
                element.errorUserId = "";
                isError.push(false);
            }

            if (element.password === '' || element.password === null) {
                element.errorPassword = "Please enter the password";
                isError.push(true);
            } else {
                element.errorPassword = "";
                isError.push(false);
            }

            if (element.aPIURL === '' || element.aPIURL === null) {
                element.errorUrl = "Please enter the Url";
                isError.push(true);
            } else {
                element.errorUrl = "";
                isError.push(false);
            }

            if (element.aPICallbackUrl === '' || element.aPICallbackUrl === null) {
                element.errorApiallBackUrl = "Please enter the Url";
                isError.push(true);
            } else {
                element.errorApiallBackUrl = "";
                isError.push(false);
            }

            if (element.aPICallbackPassword === '' || element.aPICallbackPassword === null) {
                element.errorApiallBackPassword = "Please enter the password";
                isError.push(true);
            } else {
                element.errorApiallBackPassword = "";
                isError.push(false);
            }

            if (element.aPICallback_UserName === '' || element.aPICallback_UserName === null) {
                element.errorApiallBackUserId = "Please enter the User Name";
                isError.push(true);
            } else {
                element.errorApiallBackUserId = "";
                isError.push(false);
            }
        }
        subAllSystemConfig[subAllSystemConfig.length - 1].searchCriterias.forEach((searchCriteriaElement: any, index: number) => {
            if (Number(searchCriteriaElement.fieldMappingId) === 0) {
                searchCriteriaElement.errorFieldMappingId = "Please select the Field";
                isError.push(true);
            } else {
                isError.push(false);
            }
            if (index !== 0 && Number(searchCriteriaElement.logicalOperator) === 0) {
                searchCriteriaElement.errorLogicalOperator = "Please select the AND/OR";
                isError.push(true);
            } else {
                isError.push(false);
            }
            if (Number(searchCriteriaElement.operator) === 0) {
                searchCriteriaElement.errorOperator = "Please select the Operator";
                isError.push(true);
            } else {
                isError.push(false);
            }
            if (searchCriteriaElement.value1 === '') {
                searchCriteriaElement.errorValue1 = "Please enter the Value";
                isError.push(true);
            } else {
                isError.push(false);
            }
        });

        return isError.includes(true);
    }


    const validateSaveQuery = (element: any): boolean => {
        let isError = [];
        if (element.aPI_SMB === 1) {
            if (element.aPIUserName === '') {
                element.errorUserId = "Please enter the User Name";
                isError.push(true);
            } else {
                element.errorUserId = "";
                isError.push(false);
            }

            if (element.password === '') {
                element.errorPassword = "Please enter the password";
                isError.push(true);
            } else {
                element.errorPassword = "";
                isError.push(false);
            }

            if (element.aPIURL === '') {
                element.errorUrl = "Please enter the Url";
                isError.push(true);
            } else {
                element.errorUrl = "";
                isError.push(false);
            }

            if (element.aPICallbackUrl === '') {
                element.errorApiallBackUrl = "Please enter the Url";
                isError.push(true);
            } else {
                element.errorApiallBackUrl = "";
                isError.push(false);
            }

            if (element.aPICallbackPassword === '') {
                element.errorApiallBackPassword = "Please enter the password";
                isError.push(true);
            } else {
                element.errorApiallBackPassword = "";
                isError.push(false);
            }

            if (element.aPICallback_UserName === '') {
                element.errorApiallBackUserId = "Please enter the User Name";
                isError.push(true);
            } else {
                element.errorApiallBackUserId = "";
                isError.push(false);
            }
        }
        subAllSystemConfig[nextStep].searchCriterias.forEach((searchCriteriaElement: any, index: number) => {
            if (Number(searchCriteriaElement.fieldMappingId) === 0) {
                searchCriteriaElement.errorFieldMappingId = "Please select the Field";
                isError.push(true);
            } else {
                isError.push(false);
            }
            if (index !== 0 && Number(searchCriteriaElement.logicalOperator) === 0) {
                searchCriteriaElement.errorLogicalOperator = "Please select the AND/OR";
                isError.push(true);
            } else {
                isError.push(false);
            }
            if (Number(searchCriteriaElement.operator) === 0) {
                searchCriteriaElement.errorOperator = "Please select the Operator";
                isError.push(true);
            } else {
                isError.push(false);
            }
            if (searchCriteriaElement.value1 === '') {
                searchCriteriaElement.errorValue1 = "Please enter the Value";
                isError.push(true);
            } else {
                isError.push(false);
            }
        });

        return isError.includes(true);
    }

    const handleNext = () => {
        setSteps([]);
        setNextStep(nextStep + 1);
        const newSteps = [...steps];
        newSteps[0].isDone = false;

        // Iterate over the inputGroups array in reverse order
        for (let i = 0; i < inputGroups.length; i++) {
            const inputGroup = inputGroups[i];
            if (inputGroup.subSystemName !== '' && i !== 0 && !newSteps.some(step => step.key === inputGroup.subSystemName)) {
                newSteps.push({ key: inputGroup.subSystemName, label: inputGroup.subSystemName, isDone: true });
            }
        }

        setSteps(newSteps);
        setActiveStep(newSteps[nextStep + 1]);
        // Check if the value already exists in subAllSystemConfig
        const existingConfig = subAllSystemConfig.find(
            (config) => config.subSystemName === inputGroups[nextStep+1]?.subSystemName
        );

        if (!existingConfig) {
            if (inputGroups.length !== subAllSystemConfig.length) {
                getFolders();
                getField();
                let searchCriterias = [];
                let accountSubSystemProfileKey: any[] = [];
                searchCriterias = subSystemData.length > nextStep && subSystemData[nextStep].subSytemSearchCriteriaobj.length > 0 ? subSystemData[nextStep].subSytemSearchCriteriaobj.map((searchCriteriaElement: any) => ({
                    metadataFieldName: searchCriteriaElement.metadataFieldName,
                    fieldMappingId: searchCriteriaElement.fieldMappingId,
                    logicalOperator: searchCriteriaElement.logicalOperator,
                    operator: searchCriteriaElement.operator,
                    value1: searchCriteriaElement.value1,
                    value2: searchCriteriaElement.value2,
                    subSystemSearchCriteriaID: searchCriteriaElement.subSystemSearchCriteriaID,
                    subsytemConfigurationId: searchCriteriaElement.subsytemConfigurationId,
                    fieldName: searchCriteriaElement.metadataFieldName,
                    fieldItem: {
                        metaDataFieldId: searchCriteriaElement.fieldMappingId,
                        field: searchCriteriaElement.metadataFieldName,
                        customField: searchCriteriaElement.metadataFieldName,
                        categoryName: searchCriteriaElement.categoryName,
                        fieldMappingId: searchCriteriaElement.fieldMappingId,
                    },
                })) : [{
                    metadataFieldName: '',
                    fieldMappingId: 0,
                    logicalOperator: '',
                    operator: '',
                    value1: '',
                    value2: '',
                    subSystemSearchCriteriaID: 0,
                    subsytemConfigurationId: 0,
                    fieldName: '',
                    fieldItem: {
                        metaDataFieldId: 0,
                        field: "",
                        customField: "",
                        categoryName: "",
                        fieldMappingId: 0,
                    },
                    errorFieldMappingId: '',
                    errorLogicalOperator: '',
                    errorOperator: '',
                    errorValue1: '',
                }];

                if (subSystemData && subSystemData[nextStep]?.subSystemModelobj[0].apI_SMB === 1) {
                    accountSubSystemProfileKey = subSystemData.length > nextStep && 
                                                subSystemData.length > 0 && 
                                                subSystemData[nextStep].accountSubSystemProfileKey.length > 0 ? 
                        subSystemData[nextStep].accountSubSystemProfileKey.map((profileKeyElement: any, index: number) => ({
                        accountSubSystemProfileKeyID: index + 1,
                        profileKeyName: profileKeyElement.profileKeyName,
                        isActive: profileKeyElement.isActive,
                        isDeleted: profileKeyElement.isDeleted,
                        accountSubSystemConfigurationID: profileKeyElement.accountSubSystemConfigurationID,
                        createdBy: Number(LocalStorageUtil.getItem("userId")),
                    })) : [];
                }

                const newSubAllSystemConfig = [...subAllSystemConfig, {
                    isPdfSelected: false,
                    isMetadataSelected: false,
                    isOutputPdfSelected: false,
                    isOutputMetadataSelected: false,
                    subSystemName: '',
                    searchCriterias: searchCriterias,
                    accountSubSystemProfileKey: accountSubSystemProfileKey,
                    subSystemModelobj: [{
                        errorToLocationType: '',
                        toPdfLocationId: null,
                        toMetadataLocationId: null,
                        fromType: null,
                        tolocationType: null,
                        fromLocationId: null,
                        fromMetaDataLocationId: null,
                        subSystemId: null,
                        subSystemConfigurationId: 1,
                        fromSourceMetadataDefinitionId: null,
                        toSourceMetadataDefinitionId: null,
                        isFromSourceHeaderAvailable: false,
                        isToSourceHeaderAvailable: 2,
                        aPI_SMB: 1,
                        aPIURL: "",
                        aPIUserName: "",
                        password: "",
                        aPICallbackUrl: "",
                        pdfNamingConvention: "",
                        fromLevel1: null,
                        metadataNamingConvention: "",
                        preflightErroremail: "",
                        isAllowReprocess: false,
                        frequencyHrs: null,
                        frequencyMins: null,
                        aPICallback_UserName: "",
                        aPICallbackPassword: "",
                        exportOption: 1,
                        errorUserId: '',
                        errorPassword: '',
                        errorUrl: '',
                        errorApiallBackUserId: '',
                        errorApiallBackPassword: '',
                        errorApiallBackUrl: '',
                        isImportActive: false,
                        isExportActive: false,
                        importEmailTemplateTypeId: null,
                        exportEmailTemplateTypeId: null,
                        accountSubSystemEmailConfigurationId: null,
                        createdBy: 0,
                    }]
                }]
                if (subSystemData.length > 0 && subSystemData.length > nextStep) {
                    if (subSystemData[nextStep].subSystemModelobj.length > 0) {
                        subSystemData[nextStep].subSystemModelobj.forEach((subSystemElement: any, childIndex: number) => {
                            setAccountId(subSystemElement.accountId);
                            newSubAllSystemConfig[nextStep + 1].subSystemName = subSystemData[nextStep].stageName;
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].aPI_SMB = subSystemElement.apI_SMB;
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].aPIURL = subSystemElement.apiurl;
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].aPIUserName = subSystemElement.apiUserName;
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].password = DecryptPassword(subSystemElement.password);
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].isToSourceHeaderAvailable = (subSystemElement.isToSourceHeaderAvailable ===0 || subSystemElement.isToSourceHeaderAvailable === null) ? 2 : subSystemElement.isToSourceHeaderAvailable;
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].aPICallbackUrl = subSystemElement.apiCallbackUrl;
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].pdfNamingConvention = subSystemElement.pdfNamingConvention;
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].metadataNamingConvention = subSystemElement.metadataNamingConvention;
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].preflightErroremail = subSystemElement.preflightErroremail;
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].isAllowReprocess = subSystemElement.isAllowReprocess;
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].frequencyHrs = subSystemElement.frequencyHrs;
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].frequencyMins = subSystemElement.frequencyMins;
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].aPICallback_UserName = subSystemElement.apiCallback_UserName;
                            const pass = DecryptPassword(subSystemElement.apiCallbackPassword);
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].aPICallbackPassword = pass;
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].exportOption = subSystemElement.exportOption;
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].fromLevel1 = subSystemElement.fromLevel1;
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].tolocationType = subSystemElement.tolocationType;
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].toPdfLocationId = subSystemElement.toPdfLocationId;
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].toMetadataLocationId = subSystemElement.toMetadataLocationId;
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].fromType = subSystemElement.fromType;
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].fromLocationId = subSystemElement.fromLocationId;
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].fromMetaDataLocationId = subSystemElement.fromMetaDataLocationId;
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].subSystemId = subSystemElement.subSystemId;
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].subSystemConfigurationId = subSystemElement.subSystemConfigurationId;
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].fromSourceMetadataDefinitionId = subSystemElement.fromSourceMetadataDefinitionId;
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].toSourceMetadataDefinitionId = subSystemElement.toSourceMetadataDefinitionId;
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].isFromSourceHeaderAvailable = subSystemElement.isFromSourceHeaderAvailable;
                            if (subSystemElement.apI_SMB === 2) {
                                const pdfLocation = activeFileLocations.filter((ele) => ele.ftpFolderId === subSystemElement.toPdfLocationId);
                                newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].toPdfLocationPath = pdfLocation.length > 0 ? pdfLocation[0].location : '';
                                const toMetadataLocationPath = activeFileLocations.filter((ele) => ele.ftpFolderId === subSystemElement.toMetadataLocationId);
                                newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].toMetadataLocationPath = toMetadataLocationPath.length > 0 ? toMetadataLocationPath[0].location : '';

                                const frompdfLocation = activeFileLocations.filter((ele) => ele.ftpFolderId === subSystemElement.fromLocationId);
                                newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].fromLocationPath = frompdfLocation.length > 0 ? frompdfLocation[0].location : '';
                                const fromMetadataLocationPath = activeFileLocations.filter((ele) => ele.ftpFolderId === subSystemElement.fromMetaDataLocationId);
                                newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].fromMetadataLocationPath = fromMetadataLocationPath.length > 0 ? fromMetadataLocationPath[0].location : '';

                                if (Number(subSystemElement.tolocationType) === 1 || Number(subSystemElement.tolocationType) === 5) {
                                    newSubAllSystemConfig[nextStep + 1].isPdfSelected = true;
                                    newSubAllSystemConfig[nextStep + 1].isMetadataSelected = false;
                                } else if (Number(subSystemElement.tolocationType) === 2 || Number(subSystemElement.tolocationType) === 7) {
                                    newSubAllSystemConfig[nextStep + 1].isPdfSelected = false;
                                    newSubAllSystemConfig[nextStep + 1].isMetadataSelected = true;
                                } else if (Number(subSystemElement.tolocationType) === 3 || Number(subSystemElement.tolocationType) === 6) {
                                    newSubAllSystemConfig[nextStep + 1].isPdfSelected = true;
                                    newSubAllSystemConfig[nextStep + 1].isMetadataSelected = true;
                                } else {
                                    newSubAllSystemConfig[nextStep + 1].isPdfSelected = false;
                                    newSubAllSystemConfig[nextStep + 1].isMetadataSelected = false;
                                }
                                if (Number(subSystemElement.fromType) === 1) {
                                    newSubAllSystemConfig[nextStep + 1].isOutputPdfSelected = true;
                                    newSubAllSystemConfig[nextStep + 1].isOutputMetadataSelected = false;
                                } else if (Number(subSystemElement.fromType) === 2) {
                                    newSubAllSystemConfig[nextStep + 1].isOutputPdfSelected = false;
                                    newSubAllSystemConfig[nextStep + 1].isOutputMetadataSelected = true;
                                } else if (Number(subSystemElement.fromType) === 3) {
                                    newSubAllSystemConfig[nextStep + 1].isOutputPdfSelected = true;
                                    newSubAllSystemConfig[nextStep + 1].isOutputMetadataSelected = true;
                                } else {
                                    newSubAllSystemConfig[nextStep + 1].isOutputPdfSelected = false;
                                    newSubAllSystemConfig[nextStep + 1].isOutputMetadataSelected = false;
                                }
                            }
                        });
                    }
                    if (subSystemData[nextStep].subSystemEmailConfigurationModelobj.length > 0) {
                        subSystemData[nextStep].subSystemEmailConfigurationModelobj.forEach((subSystemEmailElement: any, childIndex: number) => {
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].isImportActive = subSystemEmailElement.isImportActive;
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].isExportActive = subSystemEmailElement.isExportActive;
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].importEmailTemplateTypeId = subSystemEmailElement.importEmailTemplateTypeId;
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].exportEmailTemplateTypeId = subSystemEmailElement.exportEmailTemplateTypeId;
                            newSubAllSystemConfig[nextStep + 1].subSystemModelobj[childIndex].accountSubSystemEmailConfigurationId = subSystemEmailElement.accountSubSystemEmailConfigurationId;
                        });
                    }
                }
                SetSubAllSystemConfig(newSubAllSystemConfig);
            }
        }
    };

    const handleNextSubmit = async () => {
        if (accountNameId === undefined || accountNameId === 0) {
            showSnackbar("Please select Customer Name", true);
        } else if (inputGroups.length === 1) {
            showSnackbar("Please Add the SubSystem", true);
        } else {
            subAllSystemConfig[nextStep].subSystemModelobj.forEach((element: any, index: number) => {
                if (nextStep !== 0) {
                    if (!validateSaveQuery(element)) {
                        handleNext();
                    }
                } else {
                    handleNext();
                }
            });
        }
    };

    const getFolders = async () => {
        setLoading(true);
        const payload: any = {
            businessUnitId: Number(accountNameId),
            contextName: selectedAccountName,
        };
        try {
            const response = await GetFolders(payload);
            const { enabledFundFolders = [] } = response;
            if (enabledFundFolders.length > 0) {
                setLevel(enabledFundFolders);
            }
        } catch (error) {
            console.error("Error fetching data", error);
        } finally {
            setLoading(false);
        }
    };

    const getField = async () => {
        setLoading(true);
        const params: ListFieldModel = {
            accountId: accountId,
            contextName: selectedAccountName,
        }
        try {
            const response = await getFieldData(params);
            const transformedData = transformData(response);
            setCategories(transformedData);
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }

    const transformData = (data: any[]): Category[] => {
        const categoryMap: { [key: string]: Category } = {};

        data.forEach(item => {
            const { categoryName, fieldMappingId, field } = item;

            if (!categoryMap[categoryName]) {
                categoryMap[categoryName] = {
                    label: categoryName,
                    options: []
                };
            }

            categoryMap[categoryName].options.push({ value: fieldMappingId, label: field });
        });
        return Object.values(categoryMap);
    };

    const handleBack = () => {
        const index = steps.findIndex(x => x.key === activeStep.key);
        if (index === 0) return;

        setSteps(prevStep => prevStep.map(x => {
            if (x.key === activeStep.key) x.isDone = false;
            return x;
        }))
        setActiveStep(steps[index - 1]);
        setNextStep(nextStep - 1);
    }

    const handleAddSubSystemConfig = (index: number) => {
        const newSubSystemConfig = [...subAllSystemConfig];
        newSubSystemConfig[index].searchCriterias.push({
            metadataFieldName: '',
            fieldMappingId: 0,
            logicalOperator: '',
            operator: '',
            value1: '',
            value2: '',
            subSystemSearchCriteriaID: 0,
            subsytemConfigurationId: 0,
            fieldName: '',
            fieldItem: {
                metaDataFieldId: 0,
                field: "",
                customField: "",
                categoryName: "",
                fieldMappingId: 0,
            },
            errorFieldMappingId: '',
            errorLogicalOperator: '',
            errorOperator: '',
            errorValue1: '',
        });
        SetSubAllSystemConfig(newSubSystemConfig);
    };
    const handleDeleteSubSystemConfig = (index: number, childIndex: number) => {
        const newAllSubSystemConfig = [...subAllSystemConfig];
        newAllSubSystemConfig[index].searchCriterias = newAllSubSystemConfig[index].searchCriterias.filter((_: any, i: number) => i !== childIndex);
        SetSubAllSystemConfig(newAllSubSystemConfig);
    };

    const handleRemoveProfileKey = (accountSubSystemProfileKeyID: number, profileKeyName: any, profileName: string, currentIndex: number, subSystemData: any, selectedAccountName:string) => {
        setDialogProps({
            dialogTitle: "Delete",
            contentText: `<b>${profileName} <br /> Are you sure you want to delete this profile name?</b> Please note that "Profile" which you are deleting is selected/enabled for prefilght process.
                            <br/>If you wish to proceed please select another profile and then delete.`,
            confirmText: "OK",
            closeText: "Cancel",
            onConfirm: async () => {
                subSystemData[currentIndex - 1].accountSubSystemProfileKey.forEach((item: any) => {
                    if (item.accountSubSystemProfileKeyID === accountSubSystemProfileKeyID) {
                        handleDeleteProfileName(accountSubSystemProfileKeyID, selectedAccountName);
                    }
                });
                const newAllSubSystemConfig = [...profileKeyName];
                newAllSubSystemConfig[currentIndex].accountSubSystemProfileKey = profileKeyName[currentIndex].accountSubSystemProfileKey.filter((item: any) => item.accountSubSystemProfileKeyID !== accountSubSystemProfileKeyID);
                SetSubAllSystemConfig(newAllSubSystemConfig);
                setDialogOpen(false);
            },
        });
        setDialogOpen(true);
    }

    const handleDeleteProfileName = async (accountSubSystemProfileKeyID: number, selectedAccountName:string) => {
        setLoading(true);
        try {
            const param = {
                accountSubSystemProfileKeyID: accountSubSystemProfileKeyID,
                contextName: selectedAccountName,
            }
            const response = await DeleteProfileName(param);
            if (response) {
                showSnackbar("SubSystem Configuration Deleted Successfully");
            }
        } catch (error) {
            showSnackbar("Error fetching data", true);
        } finally {
            setLoading(false);
        }
    }

    //Action Cell Renderer
    const actionCellRenderer = (params: any) => {
        if (params.data === undefined) {
            return "";
        } else {
            return (
                <a href="#" style={{ color: "var(--aggrid-text-color)" }}>
                    <CloseIcon
                        onClick={() => handleRemoveProfileKey(params.data.accountSubSystemProfileKeyID, params.context.subAllSystemConfig, params.data.profileKeyName, params.context.nextStep, params.context.subSystemData, params.context.selectedAccountName)}
                    />
                </a>
            );
        }
    };

    const handleRadioChange = (accountSubSystemProfileKeyID: number, profileKeyName: any) => {
        const newAllSubSystemConfig = [...profileKeyName];
        newAllSubSystemConfig[nextStep + 1].accountSubSystemProfileKey.forEach((item: any) => {
            if (item.accountSubSystemProfileKeyID === accountSubSystemProfileKeyID) {
                item.isActive = true;
            } else {
                item.isActive = false;
            }
        });
        SetSubAllSystemConfig(newAllSubSystemConfig);
    };

    //Defined grid column
    const [columnDef] = useState<ColDef[]>([
        {
            headerName: "#",
            field: "accountSubSystemProfileKeyID",
            sortable: false,
            filter: false,
            resizable: false,
            width: 250,
        },
        {
            headerName: "Profile Name",
            field: "profileKeyName",
            sortable: false,
            filter: false,
            resizable: false,
            width: 500,
        },
        {
            headerName: 'Select',
            field: 'isActive',
            resizable: false,
            cellRenderer: (params: any) => {
                const { subAllSystemConfig } = params.context;
                if (params.data === undefined) {
                    return "";
                } else {
                    return (
                        <span style={{ color: "var(--aggrid-text-color)" }}>
                            <Form.Check
                                type="radio"
                                name="select"
                                style={{ marginTop: "10px" }}
                                value={params.data.isActive}
                                checked={params.data.isActive === true}
                                onChange={() => handleRadioChange(params.data.accountSubSystemProfileKeyID, subAllSystemConfig)}
                            />
                        </span>
                    );
                }
            }
        },
        {
            headerName: "Actions",
            field: "isDeleted",
            width: 250,
            sortable: false,
            resizable: false,
            cellRenderer: actionCellRenderer,
            flex: 1,
        },
    ]);

    const handleProfileNameChange = (value: string) => {
        setProfileName(value);
    }

    const handleAddProfileClick = (index: number, e: any) => {
        setErrorProfileKey('');
        if (profileName === '') {
            setErrorProfileKey('Please enter the Profile name');
            return;
        }
        e.preventDefault();
        const newAllSubSystemConfig = [...subAllSystemConfig];

        // Check if the profile key name already exists
        const profileKeyExists = newAllSubSystemConfig[index].accountSubSystemProfileKey.some(
            (item: any) => item.profileKeyName === profileName
        );

        if (profileKeyExists) {
            setErrorProfileKey('Profile key name already exists');
            return;
        }

        // Find the maximum accountSubSystemProfileKeyID in the existing array
        const maxId = newAllSubSystemConfig[index].accountSubSystemProfileKey.reduce((max: number, item: any) => {
            return item.accountSubSystemProfileKeyID > max ? item.accountSubSystemProfileKeyID : max;
        }, 0);

        // Increment the maximum accountSubSystemProfileKeyID by 1 for the new item
        const newId = maxId + 1;
        newAllSubSystemConfig[index].accountSubSystemProfileKey = [...subAllSystemConfig[index].accountSubSystemProfileKey, { accountSubSystemProfileKeyID: newId, profileKeyName: profileName, isActive: 1, isDeleted: 0 }];
        SetSubAllSystemConfig(newAllSubSystemConfig);
    }

    const handlesubSystemChange = (index: number, subSourceChildindex: number, event: React.ChangeEvent<HTMLInputElement>) => {
        setDialogProps({
            dialogTitle: "SubSystem Configuration - Create New",
            contentText: `Are you sure you want to Change the SubSystem Options?<br />
                        * Please note that, changing the options will reset the existing SubSystem settings.`,
            confirmText: "Yes",
            closeText: "No",
            onConfirm: async () => {
                handleSubSystemRadioChange(index, subSourceChildindex, event);
            },
        });
        setDialogOpen(true);
    }

    const handleSubSystemRadioChange = (index: number, subSourceChildindex: number, event: React.ChangeEvent<HTMLInputElement>) => {
        const newAllSubSystemConfig = [...subAllSystemConfig];
        newAllSubSystemConfig[index].subSystemModelobj[subSourceChildindex].aPI_SMB = Number(event.target.value);
        newAllSubSystemConfig[index].subSystemModelobj[subSourceChildindex].aPIURL = "";
        newAllSubSystemConfig[index].subSystemModelobj[subSourceChildindex].aPIUserName = "";
        newAllSubSystemConfig[index].subSystemModelobj[subSourceChildindex].password = "";
        newAllSubSystemConfig[index].subSystemModelobj[subSourceChildindex].aPICallbackUrl = "";
        newAllSubSystemConfig[index].subSystemModelobj[subSourceChildindex].pdfNamingConvention = "";
        newAllSubSystemConfig[index].subSystemModelobj[subSourceChildindex].metadataNamingConvention = "";
        newAllSubSystemConfig[index].subSystemModelobj[subSourceChildindex].preflightErroremail = "";
        newAllSubSystemConfig[index].subSystemModelobj[subSourceChildindex].isAllowReprocess = false;
        newAllSubSystemConfig[index].subSystemModelobj[subSourceChildindex].exportOption = 1;
        newAllSubSystemConfig[index].subSystemModelobj[subSourceChildindex].fromLevel1 = null;
        newAllSubSystemConfig[index].subSystemModelobj[subSourceChildindex].tolocationType = null;
        newAllSubSystemConfig[index].subSystemModelobj[subSourceChildindex].toPdfLocationId = null;
        newAllSubSystemConfig[index].subSystemModelobj[subSourceChildindex].toMetadataLocationId = null;
        newAllSubSystemConfig[index].subSystemModelobj[subSourceChildindex].fromType = null;
        newAllSubSystemConfig[index].subSystemModelobj[subSourceChildindex].fromLocationId = null;
        newAllSubSystemConfig[index].subSystemModelobj[subSourceChildindex].fromMetaDataLocationId = null;
        newAllSubSystemConfig[index].subSystemModelobj[subSourceChildindex].fromSourceMetadataDefinitionId = null;
        newAllSubSystemConfig[index].subSystemModelobj[subSourceChildindex].toSourceMetadataDefinitionId = null;
        newAllSubSystemConfig[index].subSystemModelobj[subSourceChildindex].isFromSourceHeaderAvailable = null;
        newAllSubSystemConfig[index].subSystemModelobj[subSourceChildindex].isToSourceHeaderAvailable = 2;
        newAllSubSystemConfig[index].subSystemModelobj[subSourceChildindex].isImportActive = false;
        newAllSubSystemConfig[index].subSystemModelobj[subSourceChildindex].isExportActive = false;
        newAllSubSystemConfig[index].subSystemModelobj[subSourceChildindex].toPdfLocationPath = '';
        newAllSubSystemConfig[index].subSystemModelobj[subSourceChildindex].toMetadataLocationPath = '';
        newAllSubSystemConfig[index].subSystemModelobj[subSourceChildindex].fromLocationPath = '';
        newAllSubSystemConfig[index].subSystemModelobj[subSourceChildindex].fromMetadataLocationPath = '';
        newAllSubSystemConfig[index].isPdfSelected = false;
        newAllSubSystemConfig[index].isMetadataSelected = false;
        newAllSubSystemConfig[index].isOutputPdfSelected = false;
        newAllSubSystemConfig[index].isOutputMetadataSelected = false;
        SetSubAllSystemConfig(newAllSubSystemConfig);
        setDialogOpen(false);
    };

    const getActiveFileLocation = async (accountNameId: number, accountName: string) => {
        setLoading(true);
        const payload: any = {
            businessUnitId: Number(accountNameId),
            contextName: accountName,
        };
        try {
            const activeFileLocationData = await GetActiveFileLocation(payload);
            setActiveFileLocations(activeFileLocationData);
        } catch (error) {
            console.error("Error fetching data", error);
        } finally {
            setLoading(false);
        }
    };

    const getMetadataColumns = async (accountNameId: number, accountName: string) => {
        setLoading(true);
        const payload: any = {
            businessUnitId: Number(accountNameId),
            contextName: accountName,
        };
        try {
            const metadataColumnsData = await GetMetadataColumns(payload);
            setMetadataColumns(metadataColumnsData);
        } catch (error) {
            console.error("Error fetching data", error);
        } finally {
            setLoading(false);
        }
    };

    const handleLogicalOperatorChange = (index: number, childIndex: number, event: React.ChangeEvent<HTMLSelectElement>) => {
        const newAllSubSystemConfig = [...subAllSystemConfig];
        newAllSubSystemConfig[index].searchCriterias[childIndex].logicalOperator = event.target.value;
        if (Number(event.target.value) !== 0) {
            newAllSubSystemConfig[index].searchCriterias[childIndex].errorLogicalOperator = "";
        }
        SetSubAllSystemConfig(newAllSubSystemConfig);
    };

    const handleFieldChange = (index: number, childIndex: number, event: React.ChangeEvent<HTMLSelectElement>) => {
        const newAllSubSystemConfig = [...subAllSystemConfig];
        newAllSubSystemConfig[index].searchCriterias[childIndex].fieldMappingId = event.target.value;
        newAllSubSystemConfig[index].searchCriterias[childIndex].metadataFieldName = event.target.options[event.target.selectedIndex].text;
        newAllSubSystemConfig[index].searchCriterias[childIndex].fieldItem.metaDataFieldId = event.target.value;
        newAllSubSystemConfig[index].searchCriterias[childIndex].fieldItem.field = event.target.options[event.target.selectedIndex].text;
        newAllSubSystemConfig[index].searchCriterias[childIndex].fieldItem.customField = event.target.options[event.target.selectedIndex].text;
        const optgroupElement = event.target.options[event.target.selectedIndex].parentElement;
        newAllSubSystemConfig[index].searchCriterias[childIndex].fieldItem.categoryName = optgroupElement ? (optgroupElement as HTMLOptGroupElement).label : null;
        newAllSubSystemConfig[index].searchCriterias[childIndex].fieldItem.fieldMappingId = event.target.value;
        if (Number(event.target.value) !== 0) {
            newAllSubSystemConfig[index].searchCriterias[childIndex].errorFieldMappingId = "";
        }
        SetSubAllSystemConfig(newAllSubSystemConfig);
    }

    const handleOperatorChange = (index: number, childIndex: number, event: React.ChangeEvent<HTMLSelectElement>) => {
        const newAllSubSystemConfig = [...subAllSystemConfig];
        newAllSubSystemConfig[index].searchCriterias[childIndex].operator = event.target.value;
        if (Number(event.target.value) !== 0) {
            newAllSubSystemConfig[index].searchCriterias[childIndex].errorOperator = "";
        }
        SetSubAllSystemConfig(newAllSubSystemConfig);
    };

    const handleValueChange = (index: number, childIndex: number, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newAllSubSystemConfig = [...subAllSystemConfig];
        newAllSubSystemConfig[index].searchCriterias[childIndex].value1 = event.target.value;
        if (event.target.value !== '') {
            newAllSubSystemConfig[index].searchCriterias[childIndex].errorValue1 = "";
        }
        SetSubAllSystemConfig(newAllSubSystemConfig);
    };

    const handleUserIdChange = (index: number, childIndex: number, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newAllSubSystemConfig = [...subAllSystemConfig];
        newAllSubSystemConfig[index].subSystemModelobj[childIndex].aPIUserName = event.target.value;
        SetSubAllSystemConfig(newAllSubSystemConfig);
    };

    const handlePasswordChange = (index: number, childIndex: number, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newAllSubSystemConfig = [...subAllSystemConfig];
        newAllSubSystemConfig[index].subSystemModelobj[childIndex].password = event.target.value;
        SetSubAllSystemConfig(newAllSubSystemConfig);
    };

    const handleUrlChange = (index: number, childIndex: number, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newAllSubSystemConfig = [...subAllSystemConfig];
        newAllSubSystemConfig[index].subSystemModelobj[childIndex].aPIURL = event.target.value;
        SetSubAllSystemConfig(newAllSubSystemConfig);
    };

    const handleExportChange = (index: number, childIndex: number, event: React.ChangeEvent<HTMLInputElement>) => {
        const newAllSubSystemConfig = [...subAllSystemConfig];
        newAllSubSystemConfig[index].subSystemModelobj[childIndex].isExportActive = event.target.checked;
        SetSubAllSystemConfig(newAllSubSystemConfig);
    };

    const handleHoursChange = (index: number, childIndex: number, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (Number(event.target.value) < 0) {
            event.target.value = Math.abs(Number(event.target.value)).toString();
        }
        const newAllSubSystemConfig = [...subAllSystemConfig];
        newAllSubSystemConfig[index].subSystemModelobj[childIndex].frequencyHrs = Number(event.target.value);
        SetSubAllSystemConfig(newAllSubSystemConfig);
    };

    const handleMinutesChange = (index: number, childIndex: number, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (Number(event.target.value) < 0) {
            event.target.value = Math.abs(Number(event.target.value)).toString();
        }
        const newAllSubSystemConfig = [...subAllSystemConfig];
        newAllSubSystemConfig[index].subSystemModelobj[childIndex].frequencyMins = Number(event.target.value);
        SetSubAllSystemConfig(newAllSubSystemConfig);
    };

    const handleCallBackUrlChange = (index: number, childIndex: number, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newAllSubSystemConfig = [...subAllSystemConfig];
        newAllSubSystemConfig[index].subSystemModelobj[childIndex].aPICallbackUrl = event.target.value;
        SetSubAllSystemConfig(newAllSubSystemConfig);
    };

    const handleCallBackUserIdChange = (index: number, childIndex: number, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newAllSubSystemConfig = [...subAllSystemConfig];
        newAllSubSystemConfig[index].subSystemModelobj[childIndex].aPICallback_UserName = event.target.value;
        SetSubAllSystemConfig(newAllSubSystemConfig);
    };

    const handleCallBackPasswordChange = (index: number, childIndex: number, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newAllSubSystemConfig = [...subAllSystemConfig];
        newAllSubSystemConfig[index].subSystemModelobj[childIndex].aPICallbackPassword = event.target.value;
        SetSubAllSystemConfig(newAllSubSystemConfig);
    };

    const handleLevel1Change = (index: number, childIndex: number, event: React.ChangeEvent<HTMLSelectElement>) => {
        const newAllSubSystemConfig = [...subAllSystemConfig];
        newAllSubSystemConfig[index].subSystemModelobj[childIndex].fromLevel1 = Number(event.target.value);
        SetSubAllSystemConfig(newAllSubSystemConfig);
    };

    const handleErrorMailChange = (index: number, childIndex: number, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newAllSubSystemConfig = [...subAllSystemConfig];
        newAllSubSystemConfig[index].subSystemModelobj[childIndex].preflightErroremail = event.target.value;
        SetSubAllSystemConfig(newAllSubSystemConfig);
    };

    const handleImportChange = (index: number, childIndex: number, event: React.ChangeEvent<HTMLInputElement>) => {
        const newAllSubSystemConfig = [...subAllSystemConfig];
        newAllSubSystemConfig[index].subSystemModelobj[childIndex].isImportActive = event.target.checked;
        SetSubAllSystemConfig(newAllSubSystemConfig);
    };

    const handleAllowReprocessChange = (index: number, childIndex: number, event: React.ChangeEvent<HTMLInputElement>) => {
        const newAllSubSystemConfig = [...subAllSystemConfig];
        newAllSubSystemConfig[index].subSystemModelobj[childIndex].isAllowReprocess = event.target.checked;
        SetSubAllSystemConfig(newAllSubSystemConfig);
    }

    const handleInputOptionChange = (index: number, childIndex: number, event: React.ChangeEvent<HTMLSelectElement>) => {
        const newAllSubSystemConfig = [...subAllSystemConfig];
        newAllSubSystemConfig[index].subSystemModelobj[childIndex].tolocationType = Number(event.target.value);
        if (Number(event.target.value) === 1 || Number(event.target.value) === 5) {
            newAllSubSystemConfig[index].isPdfSelected = true;
            newAllSubSystemConfig[index].isMetadataSelected = false;
        } else if (Number(event.target.value) === 2 || Number(event.target.value) === 7) {
            newAllSubSystemConfig[index].isPdfSelected = false;
            newAllSubSystemConfig[index].isMetadataSelected = true;
        } else if (Number(event.target.value) === 3 || Number(event.target.value) === 6) {
            newAllSubSystemConfig[index].isPdfSelected = true;
            newAllSubSystemConfig[index].isMetadataSelected = true;
        } else {
            newAllSubSystemConfig[index].isPdfSelected = false;
            newAllSubSystemConfig[index].isMetadataSelected = false;
        }
        SetSubAllSystemConfig(newAllSubSystemConfig);
    }

    const handleToSourceLocationChange = (index: number, childIndex: number, event: React.ChangeEvent<HTMLSelectElement>) => {
        const newAllSubSystemConfig = [...subAllSystemConfig];
        newAllSubSystemConfig[index].subSystemModelobj[childIndex].toPdfLocationId = Number(event.target.value);
        SetSubAllSystemConfig(newAllSubSystemConfig);
    };

    const handleToMetadataSourceChange = (index: number, childIndex: number, event: React.ChangeEvent<HTMLSelectElement>) => {
        const newAllSubSystemConfig = [...subAllSystemConfig];
        newAllSubSystemConfig[index].subSystemModelobj[childIndex].toMetadataLocationId = Number(event.target.value);
        SetSubAllSystemConfig(newAllSubSystemConfig);
    };

    const handleToMetadataDefinationChange = (index: number, childIndex: number, event: React.ChangeEvent<HTMLSelectElement>) => {
        const newAllSubSystemConfig = [...subAllSystemConfig];
        newAllSubSystemConfig[index].subSystemModelobj[childIndex].toSourceMetadataDefinitionId = Number(event.target.value);
        SetSubAllSystemConfig(newAllSubSystemConfig);
    };

    const handleHeaderChange = (index: number, childIndex: number, event: React.ChangeEvent<HTMLInputElement>) => {
        const newAllSubSystemConfig = [...subAllSystemConfig];
        newAllSubSystemConfig[index].subSystemModelobj[childIndex].isToSourceHeaderAvailable = Number(event.target.value);
        SetSubAllSystemConfig(newAllSubSystemConfig);
    };

    const handlePdfNamingNomChange = (index: number, childIndex: number, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newAllSubSystemConfig = [...subAllSystemConfig];
        newAllSubSystemConfig[index].subSystemModelobj[childIndex].pdfNamingConvention = event.target.value;
        SetSubAllSystemConfig(newAllSubSystemConfig);
    };

    const handleMetadataNamingChange = (index: number, childIndex: number, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newAllSubSystemConfig = [...subAllSystemConfig];
        newAllSubSystemConfig[index].subSystemModelobj[childIndex].metadataNamingConvention = event.target.value;
        SetSubAllSystemConfig(newAllSubSystemConfig);
    };

    const handleExportOptionChange = (index: number, childIndex: number, event: React.ChangeEvent<HTMLInputElement>) => {
        const newAllSubSystemConfig = [...subAllSystemConfig];
        newAllSubSystemConfig[index].subSystemModelobj[childIndex].exportOption = Number(event.target.value);
        SetSubAllSystemConfig(newAllSubSystemConfig);
    }

    const handleOutputOptionChange = (index: number, childIndex: number, event: React.ChangeEvent<HTMLSelectElement>) => {
        const newAllSubSystemConfig = [...subAllSystemConfig];
        newAllSubSystemConfig[index].subSystemModelobj[childIndex].fromType = Number(event.target.value);
        if (Number(event.target.value) === 1) {
            newAllSubSystemConfig[index].isOutputPdfSelected = true;
            newAllSubSystemConfig[index].isOutputMetadataSelected = false;
        } else if (Number(event.target.value) === 2) {
            newAllSubSystemConfig[index].isOutputPdfSelected = false;
            newAllSubSystemConfig[index].isOutputMetadataSelected = true;
        } else if (Number(event.target.value) === 3) {
            newAllSubSystemConfig[index].isOutputPdfSelected = true;
            newAllSubSystemConfig[index].isOutputMetadataSelected = true;
        } else {
            newAllSubSystemConfig[index].isOutputPdfSelected = false;
            newAllSubSystemConfig[index].isOutputMetadataSelected = false;
        }
        SetSubAllSystemConfig(newAllSubSystemConfig);
    }

    const handleFromSourceLocationChange = (index: number, childIndex: number, event: React.ChangeEvent<HTMLSelectElement>) => {
        const newAllSubSystemConfig = [...subAllSystemConfig];
        newAllSubSystemConfig[index].subSystemModelobj[childIndex].fromLocationId = Number(event.target.value);
        SetSubAllSystemConfig(newAllSubSystemConfig);
    };

    const handleFromMetadataLocationChange = (index: number, childIndex: number, event: React.ChangeEvent<HTMLSelectElement>) => {
        const newAllSubSystemConfig = [...subAllSystemConfig];
        newAllSubSystemConfig[index].subSystemModelobj[childIndex].fromMetaDataLocationId = Number(event.target.value);
        SetSubAllSystemConfig(newAllSubSystemConfig);
    };

    const handleFromMetadataDefinationChange = (index: number, childIndex: number, event: React.ChangeEvent<HTMLSelectElement>) => {
        const newAllSubSystemConfig = [...subAllSystemConfig];
        newAllSubSystemConfig[index].subSystemModelobj[childIndex].fromSourceMetadataDefinitionId = Number(event.target.value);
        SetSubAllSystemConfig(newAllSubSystemConfig);
    };

    const handleSubmit = async () => {
        setDialogProps({
            dialogTitle: "SubSystem Confirmation",
            contentText: `This will save config for ${selectedAccountName?.split('_')[1]} in ${process.env.REACT_APP_ENVIRONMENT}. Do you wish to continue?`,
            confirmText: "Yes",
            closeText: "No",
            onConfirm: async () => {
                setDialogOpen(false);
                handleSubSystemSubmit();
            },
        });
        setDialogOpen(true);
    }

    const handleSubSystemSubmit = async () => {
        if (validateSubmitQuery(subAllSystemConfig[subAllSystemConfig.length - 1].subSystemModelobj[0])) {
            return;
        }
        else {
            setLoading(true);
            let subsystemName1: any[] = [];
            let SubSystemModel: any[] = [];
            let subSystemEmailConfigurationModelobj1: any[] = [];
            let searchCriterias1: any[] = [];
            let accountSubSystemProfileKey1: any[] = [];
            if (subSystemData.length !== 0) {
                subSystemData.forEach((childElement: any, childIndex: number) => {
                    subsystemName1.push({
                        "$$hashKey": "object:1041",
                        isChecked: childElement.isChecked,
                        type: childElement.type,
                        stageName: childElement.stageName,
                        isDefault: "false",
                        customprocessid: 'cust_1',
                        order: childIndex + 1,
                        isDeleted: false,
                        businessUnitId: childElement.businessUnitId,
                        subSystemConfigurationId: childElement.subSystemConfigurationId,
                        active: childElement.active,
                    });
                });
            }
            if (inputGroups.length !== 0) {
                inputGroups.forEach((childElement: any, childIndex: number) => {
                    if (childIndex !== 0) {
                        const stageNameExists = subsystemName1.some(
                            (item: any) => item.stageName === childElement.subSystemName
                        );

                        if (!stageNameExists) {
                            subsystemName1.push({
                                "$$hashKey": "object:1043",
                                isChecked: true,
                                type: 'custom',
                                stageName: childElement.subSystemName,
                                isDefault: "false",
                                customprocessid: 'cust_1',
                                order: childIndex + 1,
                                isDeleted: false,
                            });
                        }
                    }
                });
            }
            subAllSystemConfig.forEach((element: any, index: number) => {
                let tempSearchCriterias: any[] = [];
                let tempAccountSubSystemProfileKey: any[] = [];
                if (index !== 0) {
                    element.subSystemModelobj.forEach((subElement: any, childIndex: number) => {
                        if (subSystemData[index - 1]?.stageName === element.subSystemName) {
                            SubSystemModel.push({
                                toPdfLocationId: subElement.toPdfLocationId,
                                toMetadataLocationId: subElement.toMetadataLocationId,
                                fromType: subElement.fromType,
                                tolocationType: subElement.tolocationType,
                                fromLocationId: subElement.fromLocationId,
                                fromMetaDataLocationId: subElement.fromMetaDataLocationId,
                                subSystemId: subElement.subSystemId,
                                subSystemConfigurationId: subElement.subSystemConfigurationId,
                                fromSourceMetadataDefinitionId: subElement.fromSourceMetadataDefinitionId,
                                toSourceMetadataDefinitionId: subElement.toSourceMetadataDefinitionId,
                                isFromSourceHeaderAvailable: subElement.isFromSourceHeaderAvailable,
                                isToSourceHeaderAvailable: subElement.isToSourceHeaderAvailable,
                                aPI_SMB: subElement.aPI_SMB,
                                aPIURL: subElement.aPIURL === "" ? null : subElement.aPIURL,
                                aPIUserName: subElement.aPIUserName === "" ? null : subElement.aPIUserName,
                                password: subElement.password === "" ? null : subElement.password,
                                aPICallbackUrl: subElement.aPICallbackUrl === "" ? null : subElement.aPICallbackUrl,
                                pdfNamingConvention: subElement.pdfNamingConvention === "" ? null : subElement.pdfNamingConvention,
                                fromLevel1: subElement.fromLevel1,
                                metadataNamingConvention: subElement.metadataNamingConvention === "" ? null : subElement.metadataNamingConvention,
                                preflightErroremail: subElement.preflightErroremail === "" ? null : subElement.preflightErroremail,
                                isAllowReprocess: subElement.isAllowReprocess,
                                frequencyHrs: subElement.frequencyHrs,
                                frequencyMins: subElement.frequencyMins,
                                aPICallback_UserName: subElement.aPICallback_UserName,
                                aPICallbackPassword: subElement.aPICallbackPassword === "" ? "" : subElement.aPICallbackPassword,
                                exportOption: subElement.exportOption,
                            });
                            subSystemEmailConfigurationModelobj1.push({
                                isImportActive: subElement.isImportActive,
                                isExportActive: subElement.isExportActive,
                                importEmailTemplateTypeId: subElement.importEmailTemplateTypeId === 0 ? null : subElement.importEmailTemplateTypeId,
                                exportEmailTemplateTypeId: subElement.exportEmailTemplateTypeId === 0 ? null : subElement.exportEmailTemplateTypeId,
                                accountSubSystemEmailConfigurationId: subElement.accountSubSystemEmailConfigurationId === 0 ? null : subElement.accountSubSystemEmailConfigurationId,
                                createdBy: Number(LocalStorageUtil.getItem("userId")),
                            });
                        } else {
                            SubSystemModel.push({
                                aPI_SMB: subElement.aPI_SMB,
                                aPICallback_UserName: subElement.aPICallback_UserName,
                                aPICallbackPassword: subElement.aPICallbackPassword === "" ? null : subElement.aPICallbackPassword,
                                aPICallbackUrl: subElement.aPICallbackUrl === "" ? null : subElement.aPICallbackUrl,
                                aPIURL: subElement.aPIURL === "" ? null : subElement.aPIURL,
                                aPIUserName: subElement.aPIUserName === "" ? null : subElement.aPIUserName,
                                fromType: subElement.fromType,
                                password: subElement.password === "" ? null : subElement.password,
                                tolocationType: subElement.tolocationType,
                                toPdfLocationId: subElement.toPdfLocationId
                            });
                            subSystemEmailConfigurationModelobj1.push({
                                isImportActive: subElement.isImportActive,
                                isExportActive: subElement.isExportActive,
                                createdBy: Number(LocalStorageUtil.getItem("userId")),
                            });
                        }
                    });
                    element.searchCriterias.forEach((subElement: any, childIndex: number) => {
                        if (subSystemData[index - 1]?.stageName === element.subSystemName) {
                            tempSearchCriterias.push({
                                MetadataFieldName: subElement.metadataFieldName,
                                fieldMappingId: Number(subElement.fieldMappingId),
                                fieldItem: {
                                    "$$hashKey": "object:1088",
                                    metaDataFieldId: Number(subElement.fieldMappingId),
                                    field: subElement.metadataFieldName,
                                    customField: subElement.metadataFieldName,
                                    categoryName: subElement.categoryName ?? "",
                                    fieldMappingId: Number(subElement.fieldMappingId),
                                },
                                LogicalOperator: subElement.logicalOperator === "" ? null : subElement.logicalOperator,
                                Operator: subElement.operator,
                                Value1: subElement.value1,
                                Value2: subElement.value2,
                                SubSystemSearchCriteriaID: subElement.SubSystemSearchCriteriaID === 0 ? null : subElement.subSystemSearchCriteriaID,
                                SubsytemConfigurationId: subElement.SubsytemConfigurationId === 0 ? null : subElement.subsytemConfigurationId,
                                fieldName: subElement.metadataFieldName,
                            });
                        } else {
                            tempSearchCriterias.push({
                                MetadataFieldName: subElement.metadataFieldName,
                                fieldMappingId: Number(subElement.fieldMappingId),
                                fieldItem: {
                                    "$$hashKey": "object:1088",
                                    metaDataFieldId: Number(subElement.fieldMappingId),
                                    field: subElement.metadataFieldName,
                                    customField: subElement.metadataFieldName,
                                    categoryName: subElement.categoryName ?? "",
                                    fieldMappingId: Number(subElement.fieldMappingId),
                                },
                                LogicalOperator: subElement.logicalOperator === "" ? null : subElement.logicalOperator,
                                Operator: subElement.operator,
                                Value1: subElement.value1,
                                Value2: subElement.value2 === "" ? null : subElement.value2,
                                fieldName: subElement.metadataFieldName,
                            });
                        }
                    });
                    searchCriterias1.push(tempSearchCriterias);
                    element.accountSubSystemProfileKey.forEach((subElement: any, childIndex: number) => {
                        if (subSystemData[index - 1]?.stageName === element.subSystemName) {
                            tempAccountSubSystemProfileKey.push({
                                accountSubSystemProfileKeyID: subElement.accountSubSystemProfileKeyID,
                                accountSubSystemConfigurationID: subElement.accountSubSystemConfigurationID,
                                profileKeyName: subElement.profileKeyName,
                                isActive: subElement.isActive,
                                isDeleted: subElement.isDeleted,
                                createdBy: Number(LocalStorageUtil.getItem("userId")),
                                createdDate: new Date(),
                                contextName: null,
                            });
                        } else {
                            tempAccountSubSystemProfileKey.push({
                                "$$hashKey": "object:1169",
                                createdBy: Number(LocalStorageUtil.getItem("userId")),
                                isActive: subElement.isActive,
                                isDeleted: subElement.isDeleted,
                                profileKeyName: subElement.profileKeyName,
                            });
                        }
                    });
                    accountSubSystemProfileKey1.push(tempAccountSubSystemProfileKey);
                }
            });

            const subSystelConfigModel = {
                accountId: accountId,
                subsystemName: subsystemName1,
            }

            const cleanedList = accountSubSystemProfileKey1.filter(
                (item) => !(Array.isArray(item) && item.length === 0)
            );

            let paramPost = {
                AccountSubSystemProfileKey: cleanedList,
                contextName: selectedAccountName ?? "",
                DeletedSubSystemConfigurationId: [],
                SearchCriterias: searchCriterias1,
                subSystemConfigurationModelobj: subSystelConfigModel,
                subSystemEmailConfigurationModelobj: subSystemEmailConfigurationModelobj1,
                subSystemModelobj: SubSystemModel,
            }

            try {
                await CreateSubSystemConfiguration(paramPost);
                showSnackbar("SubSystem Configuration created successfully");
                handleReset();
            } catch (error) {
                showSnackbar("Error creating SubSystem Configuration", true);
            } finally {
                setLoading(false);
            }
        }
    }

    const handleReset = () => {
        setSteps([{ key: 'firstStep', label: 'Basic Information', isDone: true }]);
        setActiveStep({ key: 'firstStep', label: 'Basic Information', isDone: true });
        setNextStep(0);
        setAccountNameId(0);
        setInputGroups([{ subSystemName: '' }]);
        setProfileName('');
        setErrorProfileKey('');
        setSubSystemData([{
            subSystemConfigurationId: 1,
            isPdfSelected: false,
            isMetadataSelected: false,
            isOutputPdfSelected: false,
            isOutputMetadataSelected: false,
            searchCriterias:
                [{
                    metadataFieldName: '',
                    fieldMappingId: null,
                    logicalOperator: '',
                    operator: '',
                    value1: '',
                    value2: '',
                    subSystemSearchCriteriaID: null,
                    subsytemConfigurationId: null,
                    fieldName: '',
                    fieldItem: {
                        metaDataFieldId: null,
                        field: "",
                        customField: "",
                        categoryName: "",
                        fieldMappingId: null,
                    },
                    errorFieldMappingId: '',
                    errorLogicalOperator: '',
                    errorOperator: '',
                    errorValue1: '',
                }],
            accountSubSystemProfileKey: [],
            subSystemModelobj: [{
                toPdfLocationId: null,
                toMetadataLocationId: null,
                fromType: null,
                tolocationType: null,
                fromLocationId: null,
                fromMetaDataLocationId: null,
                subSystemId: null,
                subSystemConfigurationId: null,
                fromSourceMetadataDefinitionId: null,
                toSourceMetadataDefinitionId: null,
                isFromSourceHeaderAvailable: false,
                isToSourceHeaderAvailable: 2,
                aPI_SMB: 1,
                aPIURL: "",
                aPIUserName: "",
                password: "",
                aPICallbackUrl: "",
                pdfNamingConvention: "",
                fromLevel1: null,
                metadataNamingConvention: "",
                preflightErroremail: "",
                isAllowReprocess: false,
                frequencyHrs: null,
                frequencyMins: null,
                aPICallback_UserName: "",
                aPICallbackPassword: "",
                exportOption: 1,
                errorUserId: '',
                errorPassword: '',
                errorUrl: '',
                errorApiallBackUserId: '',
                errorApiallBackPassword: '',
                errorApiallBackUrl: '',
                isImportActive: false,
                isExportActive: false,
                importEmailTemplateTypeId: null,
                exportEmailTemplateTypeId: null,
                accountSubSystemEmailConfigurationId: null,
                createdBy: null,
            }]
        }]);
    }

  return (
    <div>
      <NavigationBar
        menuTitle="Configuration"
        title="SubSystem-Configuration"
        text="SubSystem Configuration - Create New"
        screenTitle="Create"
      />
      <ConfirmationDialog
        open={dialogOpen}
        onConfirm={dialogProps.onConfirm}
        onClose={setDialogOpen.bind(this, false)}
        contentText={dialogProps.contentText}
        closeText={dialogProps.closeText}
        confirmText={dialogProps.confirmText}
        dialogTitle={dialogProps.dialogTitle}
      />
      <div className="box">
        <div className="steps" style={{ marginLeft: "20px" }}>
          <ul className="nav">
            {steps.map((step, i) => {
              return (
                <li
                  key={step.key}
                  className={`${activeStep.key === step.key ? "active" : ""} ${
                    step.isDone ? "done" : ""
                  }`}
                >
                  {activeStep.key === step.key ? (
                    <div className={styles.activeClass}>
                      <span>Step</span> <span>{i + 1}</span>
                      <br />
                      <span>{step.label}</span>
                    </div>
                  ) : (
                    <div
                      className={`${
                        i === 0
                          ? styles.deactiveClass
                          : styles.deactiveClassChild
                      }`}
                    >
                      <span>Step</span>{" "}
                      <span style={{ marginLeft: "10px" }}>{i + 1}</span>
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
        <div className="step-component">
          {nextStep !== 0 && (
            <Button
              variant="outlined"
              type="button"
              onClick={handleBack}
              color="primary"
              className={styles.btnClass}
            >
              Previous
            </Button>
          )}
          {nextStep === 0 || nextStep < steps.length - 1 ? (
            <Button
              variant="outlined"
              type="button"
              onClick={handleNextSubmit}
              color="primary"
              className={styles.btnClass}
            >
              Next
            </Button>
          ) : (
            <Button
              variant="outlined"
              type="button"
              onClick={handleSubmit}
              color="primary"
              className={styles.btnClass}
            >
              Submit
            </Button>
          )}
          {nextStep === 0 && (
            <Form>
              <h5
                style={{
                  color: "var(--aggrid-text-color)",
                  marginTop: "10px",
                  fontSize: "12px",
                  fontWeight: "600",
                }}
              >
                BASIC INFORMATION
              </h5>
              <Row className="mb-3" style={{ display: "block" }}>
                <Col md={3}>
                  <>{console.log("Next Step: ", accountName)}</>
                  <Form.Group controlId="formCustomer" style={{ width: "89%" }}>
                    <Form.Label
                      className="input-labels"
                      style={{
                        color: "var(--aggrid-text-color)",
                        fontSize: "11px",
                      }}
                    >
                      Enter the Customer Name
                      <span
                        style={{ color: "var(--aggrid-text-color)" }}
                        className="required"
                      >
                        *
                      </span>
                    </Form.Label>
                    <Form.Select
                      name="customerId"
                      value={accountNameId}
                      onChange={handleCustomerNameChange}
                      style={{ fontSize: "11px" }}
                    >
                      <option value="0">Select</option>
                      {accountName.map((accName: any) => (
                        <option
                          key={accName.businessUnitId}
                          value={accName.businessUnitId}
                        >
                          {accName.accountName}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              <h5
                style={{
                  color: "var(--aggrid-text-color)",
                  marginTop: "15px",
                  fontSize: "12px",
                  fontWeight: "600",
                }}
              >
                SUB-SYSTEM CONFIGURATION
                <span
                  style={{ color: "var(--aggrid-text-color)" }}
                  className="required"
                >
                  *
                </span>
              </h5>
              <div style={{ border: "2px solid", padding: "15px" }}>
                <Row className="mb-3">
                  {inputGroups.map((inputGroup, index) => (
                    <>
                      <Col md={3} style={index === 0 ? { width: "100%" } : {}}>
                        <Form.Group
                          controlId="formCustomer"
                          style={{
                            fontSize: "11px",
                            display: "inline-block",
                            marginBottom: "20px",
                            width: index === 0 ? "19%" : "80%",
                          }}
                        >
                          <Form.Control
                            type="text"
                            placeholder="Enter the SubSystem Name"
                            value={inputGroup.subSystemName}
                            id={`txtSourceName_${index}`}
                            name={inputGroup.subSystemName}
                            onChange={(event) =>
                              handleSearchChange(index, event)
                            }
                            required
                            style={{ fontSize: "11px" }}
                          />
                        </Form.Group>
                        {index === 0 && (
                          <AddBoxIcon
                            style={{
                              marginLeft: "10px",
                              color: "var(--button-color)",
                            }}
                            onClick={() => handleAddInputGroup(index)}
                          ></AddBoxIcon>
                        )}
                        {index !== 0 && (
                          <DeleteForeverIcon
                            style={{
                              marginLeft: "10px",
                              color: "var(--button-color)",
                            }}
                            onClick={() =>
                              handleDeleteSource(
                                index,
                                inputGroup.subSystemName
                              )
                            }
                          ></DeleteForeverIcon>
                        )}
                      </Col>
                      <ConfirmationDialog
                        open={dialogOpen}
                        onConfirm={dialogProps.onConfirm}
                        onClose={setDialogOpen.bind(this, false)}
                        contentText={dialogProps.contentText}
                        closeText={dialogProps.closeText}
                        confirmText={dialogProps.confirmText}
                        dialogTitle={dialogProps.dialogTitle}
                      />
                    </>
                  ))}
                </Row>
              </div>
            </Form>
          )}
          {/* istanbul ignore next */}
          {nextStep !== 0 && (
            <div>
              {subAllSystemConfig.map((allSystemConfig, index) => (
                <>
                  {index === nextStep && (
                    <form>
                      <h5
                        style={{
                          color: "var(--aggrid-text-color)",
                          marginTop: "10px",
                          fontSize: "12px",
                        }}
                      >
                        SUB SYSTEM SCENARIO CONFIGURATION
                      </h5>
                      <Row>
                        <Col>
                          <div style={{ border: "2px solid", padding: "15px" }}>
                            <div style={{ display: "flex" }}>
                              <InputLabel
                                style={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                  color: "var(--text-color)",
                                  display: "inline-block !important",
                                  marginBottom: "5px !important",
                                  fontWeight: 600,
                                  fontSize: "11px",
                                  marginLeft: "7px",
                                }}
                              >
                                AND/OR
                              </InputLabel>
                              <InputLabel
                                style={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                  color: "var(--text-color)",
                                  display: "inline-block !important",
                                  marginBottom: "5px !important",
                                  fontWeight: 600,
                                  fontSize: "11px",
                                  marginLeft: "12ch",
                                }}
                              >
                                Field
                              </InputLabel>
                              <InputLabel
                                style={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                  color: "var(--text-color)",
                                  display: "inline-block !important",
                                  marginBottom: "5px !important",
                                  fontWeight: 600,
                                  fontSize: "11px",
                                  marginLeft: "20ch",
                                }}
                              >
                                Operator
                              </InputLabel>
                              <InputLabel
                                style={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                  color: "var(--text-color)",
                                  display: "inline-block !important",
                                  marginBottom: "5px !important",
                                  fontWeight: 600,
                                  fontSize: "11px",
                                  marginLeft: "13ch",
                                }}
                              >
                                Value
                              </InputLabel>
                            </div>

                            {allSystemConfig.searchCriterias.map(
                              (searchCriteria: any, childIndex: number) => (
                                <>
                                  <div
                                    key={
                                      searchCriteria.fieldMappingId ||
                                      searchCriteria.metadataFieldName ||
                                      childIndex
                                    }
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      marginBottom: "5px",
                                    }}
                                  >
                                    {childIndex !== 0 && (
                                      <select
                                        id={`andor_${childIndex}`}
                                        value={searchCriteria.logicalOperator}
                                        name={searchCriteria.logicalOperator}
                                        style={{
                                          paddingTop: "0px",
                                          backgroundColor: "white",
                                          display: "inline-block !important",
                                          alignItems: "center",
                                          width: "17ch",
                                          marginLeft: "1ch",
                                          height: "25px",
                                          fontSize: "11px",
                                        }}
                                        onChange={(e) =>
                                          handleLogicalOperatorChange(
                                            index,
                                            childIndex,
                                            e
                                          )
                                        }
                                      >
                                        <option aria-label="None" value="0">
                                          Select
                                        </option>
                                        {andOr.map((option) => (
                                          <option
                                            key={option.value}
                                            value={option.value}
                                          >
                                            {option.label}
                                          </option>
                                        ))}
                                      </select>
                                    )}
                                    <select
                                      id={`field_${childIndex}`}
                                      value={searchCriteria.fieldMappingId}
                                      name={searchCriteria.fieldMappingId}
                                      style={{
                                        paddingTop: "0px",
                                        backgroundColor: "white",
                                        display: "inline-block !important",
                                        alignItems: "center",
                                        width: "23ch",
                                        marginLeft:
                                          childIndex !== 0 ? "2ch" : "20ch",
                                        height: "25px",
                                        fontSize: "11px",
                                      }}
                                      onChange={(event) =>
                                        handleFieldChange(
                                          index,
                                          childIndex,
                                          event
                                        )
                                      }
                                    >
                                      <option aria-label="None" value="0">
                                        Select
                                      </option>
                                      {categories.map((category) => (
                                        <optgroup
                                          key={category.label}
                                          label={category.label}
                                        >
                                          {category.options.map((option) => (
                                            <option
                                              key={option.value}
                                              value={option.value}
                                            >
                                              {option.label}
                                            </option>
                                          ))}
                                        </optgroup>
                                      ))}
                                    </select>
                                    <select
                                      id={`operator_${childIndex}`}
                                      value={searchCriteria.operator}
                                      name={searchCriteria.operator}
                                      style={{
                                        paddingTop: "0px",
                                        backgroundColor: "white",
                                        display: "inline-block !important",
                                        alignItems: "center",
                                        width: "18ch",
                                        marginLeft: "1ch",
                                        height: "25px",
                                        fontSize: "11px",
                                      }}
                                      onChange={(event) =>
                                        handleOperatorChange(
                                          index,
                                          childIndex,
                                          event
                                        )
                                      }
                                    >
                                      <option aria-label="None" value="0">
                                        Select
                                      </option>
                                      {operator.map((option) => (
                                        <option
                                          key={option.value}
                                          value={option.value}
                                        >
                                          {option.label}
                                        </option>
                                      ))}
                                    </select>
                                    <TextField
                                      variant="outlined"
                                      fullWidth
                                      style={{
                                        paddingTop: "0px",
                                        backgroundColor: "white",
                                        display: "inline-block !important",
                                        alignItems: "center",
                                        width: "40ch",
                                        marginLeft: "15px",
                                        padding: "2px",
                                        height: "25px",
                                        fontSize: "11px",
                                      }}
                                      InputProps={{
                                        style: {
                                          height: "25px",
                                          fontSize: "11px",
                                        },
                                      }}
                                      id={`txtSimpleSearch_${childIndex}`}
                                      name={searchCriteria.value1}
                                      value={searchCriteria.value1}
                                      onChange={(event) =>
                                        handleValueChange(
                                          index,
                                          childIndex,
                                          event
                                        )
                                      }
                                    >
                                      <MenuItem
                                        style={{ fontSize: "11px" }}
                                      ></MenuItem>
                                    </TextField>
                                    {childIndex !== 0 && (
                                      <DeleteForeverIcon
                                        style={{ color: "var(--button-color)" }}
                                        onClick={() =>
                                          handleDeleteSubSystemConfig(
                                            index,
                                            childIndex
                                          )
                                        }
                                      ></DeleteForeverIcon>
                                    )}
                                    {childIndex ===
                                      subAllSystemConfig[index].searchCriterias
                                        .length -
                                        1 && (
                                      <AddBoxIcon
                                        style={{ color: "var(--button-color)" }}
                                        onClick={() =>
                                          handleAddSubSystemConfig(index)
                                        }
                                      ></AddBoxIcon>
                                    )}
                                  </div>
                                  <div style={{ marginBottom: "20px" }}>
                                    {searchCriteria.errorLogicalOperator && (
                                      <Typography
                                        color="error"
                                        variant="body2"
                                        style={{
                                          fontSize: "11px",
                                          marginBottom: "5px",
                                          position: "absolute",
                                          marginLeft: "2ch",
                                          color: "red",
                                        }}
                                      >
                                        {searchCriteria.errorLogicalOperator}
                                      </Typography>
                                    )}
                                    {searchCriteria.errorFieldMappingId && (
                                      <Typography
                                        color="error"
                                        variant="body2"
                                        style={{
                                          fontSize: "11px",
                                          marginBottom: "5px",
                                          position: "absolute",
                                          marginLeft: "16em",
                                          color: "red",
                                        }}
                                      >
                                        {searchCriteria.errorFieldMappingId}
                                      </Typography>
                                    )}
                                    {searchCriteria.errorOperator && (
                                      <Typography
                                        color="error"
                                        variant="body2"
                                        style={{
                                          fontSize: "11px",
                                          marginBottom: "5px",
                                          position: "absolute",
                                          marginLeft: "34em",
                                          color: "red",
                                        }}
                                      >
                                        {searchCriteria.errorOperator}
                                      </Typography>
                                    )}
                                    {searchCriteria.errorValue1 && (
                                      <Typography
                                        color="error"
                                        variant="body2"
                                        style={{
                                          fontSize: "11px",
                                          marginBottom: "5px",
                                          position: "absolute",
                                          marginLeft: "50em",
                                          color: "red",
                                        }}
                                      >
                                        {searchCriteria.errorValue1}
                                      </Typography>
                                    )}
                                  </div>
                                </>
                              )
                            )}
                          </div>
                        </Col>
                      </Row>
                      {allSystemConfig.subSystemModelobj.map(
                        (
                          subSystemModelobj: any,
                          subSourceChildindex: number
                        ) => (
                          <>
                            <Row>
                              <Col
                                style={{
                                  marginTop: "5px",
                                  width: "125px",
                                  color: "var(--aggrid-text-color)",
                                }}
                              >
                                <h5
                                  style={{
                                    color: "var(--aggrid-text-color)",
                                    marginTop: "10px",
                                    fontSize: "12px",
                                  }}
                                >
                                  SUB SYSTEM OPTIONS
                                </h5>
                                <span style={{ display: "flex" }}>
                                  <Form.Check
                                    type="radio"
                                    name={`subSystemOptions_${subSourceChildindex}`}
                                    value="1"
                                    label="API"
                                    style={{
                                      marginTop: "10px",
                                      fontSize: "11px",
                                    }}
                                    checked={subSystemModelobj.aPI_SMB === 1}
                                    onChange={(event) =>
                                      handlesubSystemChange(
                                        index,
                                        subSourceChildindex,
                                        event
                                      )
                                    }
                                  />
                                  <Form.Check
                                    type="radio"
                                    name={`subSystemOptions_${subSourceChildindex}`}
                                    value="2"
                                    label="Network"
                                    style={{
                                      marginLeft: "8px",
                                      marginTop: "10px",
                                      fontSize: "11px",
                                    }}
                                    checked={subSystemModelobj.aPI_SMB === 2}
                                    onChange={(event) =>
                                      handlesubSystemChange(
                                        index,
                                        subSourceChildindex,
                                        event
                                      )
                                    }
                                  />
                                </span>
                              </Col>
                            </Row>
                            {subSystemModelobj.aPI_SMB === 1 && (
                              <>
                                <h5
                                  style={{
                                    color: "var(--aggrid-text-color)",
                                    marginTop: "10px",
                                    fontSize: "12px",
                                  }}
                                >
                                  INPUT SETTINGS
                                </h5>
                                <span
                                  style={{
                                    color: "var(--aggrid-text-color)",
                                    fontSize: "12px",
                                  }}
                                >
                                  (DocDistro to Other Systems)
                                </span>
                                <Row md={12}>
                                  <Col md={3}>
                                    <Form.Group
                                      controlId="formGroupName"
                                      style={{
                                        display: "inline-block",
                                        width: "100%",
                                        marginTop: "10px",
                                      }}
                                    >
                                      <Form.Label
                                        className="input-labels"
                                        style={{
                                          color: "var(--aggrid-text-color)",
                                          fontSize: "11px",
                                        }}
                                      >
                                        User ID{" "}
                                        <span
                                          style={{
                                            color: "var(--aggrid-text-color)",
                                            fontSize: "11px",
                                          }}
                                          className="required"
                                        >
                                          *
                                        </span>
                                      </Form.Label>
                                      <Form.Control
                                        type="text"
                                        placeholder="Enter the User ID"
                                        name={`userId_${subSourceChildindex}`}
                                        value={subSystemModelobj.aPIUserName}
                                        onChange={(event) =>
                                          handleUserIdChange(
                                            index,
                                            subSourceChildindex,
                                            event
                                          )
                                        }
                                        style={{ fontSize: "11px" }}
                                      />
                                    </Form.Group>
                                    {subSystemModelobj.errorUserId && (
                                      <span
                                        style={{
                                          color: "red",
                                          marginLeft: "0px",
                                        }}
                                      >
                                        {subSystemModelobj.errorUserId}
                                      </span>
                                    )}
                                  </Col>
                                  <Col md={3}>
                                    <Form.Group
                                      controlId="formGroupName"
                                      style={{
                                        display: "inline-block",
                                        width: "100%",
                                        marginTop: "10px",
                                      }}
                                    >
                                      <Form.Label
                                        className="input-labels"
                                        style={{
                                          color: "var(--aggrid-text-color)",
                                          fontSize: "11px",
                                        }}
                                      >
                                        Password{" "}
                                        <span
                                          style={{
                                            color: "var(--aggrid-text-color)",
                                            fontSize: "11px",
                                          }}
                                          className="required"
                                        >
                                          *
                                        </span>
                                      </Form.Label>
                                      <Form.Control
                                        type="password"
                                        placeholder="Enter the password"
                                        name={`password_${subSourceChildindex}`}
                                        value={subSystemModelobj.password}
                                        onChange={(event) =>
                                          handlePasswordChange(
                                            index,
                                            subSourceChildindex,
                                            event
                                          )
                                        }
                                        style={{ fontSize: "11px" }}
                                      />
                                    </Form.Group>
                                    {subSystemModelobj.errorPassword && (
                                      <span
                                        style={{
                                          color: "red",
                                          marginLeft: "0px",
                                        }}
                                      >
                                        {subSystemModelobj.errorPassword}
                                      </span>
                                    )}
                                  </Col>
                                </Row>
                                <Row md={12}>
                                  <Col md={3}>
                                    <Form.Group
                                      controlId="formGroupName"
                                      style={{
                                        display: "inline-block",
                                        width: "100%",
                                        marginTop: "10px",
                                      }}
                                    >
                                      <Form.Label
                                        className="input-labels"
                                        style={{
                                          color: "var(--aggrid-text-color)",
                                          fontSize: "11px",
                                        }}
                                      >
                                        URL{" "}
                                        <span
                                          style={{
                                            color: "var(--aggrid-text-color)",
                                            fontSize: "11px",
                                          }}
                                          className="required"
                                        >
                                          *
                                        </span>
                                      </Form.Label>
                                      <Form.Control
                                        type="text"
                                        placeholder="Enter the Url"
                                        name={`url_${subSourceChildindex}`}
                                        value={subSystemModelobj.aPIURL}
                                        onChange={(event) =>
                                          handleUrlChange(
                                            index,
                                            subSourceChildindex,
                                            event
                                          )
                                        }
                                        style={{ fontSize: "11px" }}
                                      />
                                    </Form.Group>
                                    {subSystemModelobj.errorUrl && (
                                      <span
                                        style={{
                                          color: "red",
                                          marginLeft: "0px",
                                        }}
                                      >
                                        {subSystemModelobj.errorUrl}
                                      </span>
                                    )}
                                  </Col>
                                  <Col
                                    md={3}
                                    style={{
                                      marginTop: "25px",
                                      color: "var(--aggrid-text-color)",
                                      fontSize: "11px",
                                    }}
                                  >
                                    Export
                                    <Form.Check
                                      type="checkbox"
                                      name={`fromHeader_${subSourceChildindex}`}
                                      value={subSystemModelobj.isExportActive}
                                      style={{ marginTop: "10px" }}
                                      checked={subSystemModelobj.isExportActive}
                                      onChange={(event) =>
                                        handleExportChange(
                                          index,
                                          subSourceChildindex,
                                          event
                                        )
                                      }
                                    />
                                  </Col>
                                </Row>
                                <h5
                                  style={{
                                    color: "var(--aggrid-text-color)",
                                    marginTop: "10px",
                                    fontSize: "12px",
                                  }}
                                >
                                  PROFILE
                                </h5>
                                <Row md={12}>
                                  <Col md={6}>
                                    <Form.Group
                                      controlId="formGroupName"
                                      style={{
                                        display: "inline-block",
                                        width: "60%",
                                        marginTop: "10px",
                                        fontSize: "11px",
                                      }}
                                    >
                                      <Form.Label
                                        className="input-labels"
                                        style={{
                                          color: "var(--aggrid-text-color)",
                                        }}
                                      >
                                        Profile Name
                                      </Form.Label>
                                      <Form.Control
                                        type="text"
                                        placeholder="Please enter the Profile Name"
                                        name="profileName"
                                        value={profileName}
                                        onChange={(e) =>
                                          handleProfileNameChange(
                                            e.target.value
                                          )
                                        }
                                        style={{ fontSize: "11px" }}
                                      />
                                    </Form.Group>
                                    <Button
                                      className={styles.btnAddClass}
                                      style={{
                                        fontSize: "11px",
                                        height: "25px",
                                        marginTop: "10px",
                                        marginLeft: "10px",
                                      }}
                                      onClick={(e) =>
                                        handleAddProfileClick(index, e)
                                      }
                                    >
                                      Add
                                    </Button>
                                  </Col>
                                  {errorProfileKey && (
                                    <span
                                      style={{
                                        color: "red",
                                        marginLeft: "0px",
                                      }}
                                    >
                                      {errorProfileKey}
                                    </span>
                                  )}
                                </Row>
                                <div
                                  style={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "10em",
                                  }}
                                >
                                  <div
                                    className="ag-theme-quartz-dark"
                                    style={{
                                      height: "10em",
                                      width: "auto",
                                      marginTop: "10px",
                                    }}
                                  >
                                    <AgGridReact
                                      rowData={
                                        allSystemConfig.accountSubSystemProfileKey
                                      }
                                      columnDefs={columnDef}
                                      rowSelection="multiple"
                                      suppressRowClickSelection={true}//NOSONAR
                                      context={{
                                        subAllSystemConfig,
                                        nextStep,
                                        subSystemData,
                                        selectedAccountName,
                                      }}
                                    />
                                  </div>
                                </div>
                                <span
                                  style={{
                                    color: "var(--aggrid-text-color)",
                                    marginTop: "10px",
                                    fontSize: "12px",
                                  }}
                                >
                                  Set Communication Frequency :
                                </span>
                                <Row>
                                  <Col md={1}>
                                    <Form.Group
                                      controlId="formGroupName"
                                      style={{
                                        width: "120%",
                                        marginTop: "10px",
                                        display: "flex",
                                      }}
                                    >
                                      <Form.Control
                                        type="number"
                                        placeholder="0"
                                        name={`hours_${subSourceChildindex}`}
                                        value={subSystemModelobj.frequencyHrs}
                                        onChange={(event) =>
                                          handleHoursChange(
                                            index,
                                            subSourceChildindex,
                                            event
                                          )
                                        }
                                        min="0"
                                        style={{ fontSize: "11px" }}
                                      />
                                      <span
                                        style={{
                                          color: "var(--aggrid-text-color)",
                                          marginLeft: "5px",
                                          marginTop: "5px",
                                          fontSize: "11px",
                                        }}
                                      >
                                        Hour
                                      </span>
                                    </Form.Group>
                                  </Col>
                                  <Col md={1}>
                                    <Form.Group
                                      controlId="formGroupName"
                                      style={{
                                        width: "140%",
                                        marginLeft: "10px",
                                        marginTop: "10px",
                                        display: "flex",
                                      }}
                                    >
                                      <Form.Control
                                        type="number"
                                        placeholder="0"
                                        name={`minute_${subSourceChildindex}`}
                                        value={subSystemModelobj.frequencyMins}
                                        onChange={(event) =>
                                          handleMinutesChange(
                                            index,
                                            subSourceChildindex,
                                            event
                                          )
                                        }
                                        min="0"
                                        style={{ fontSize: "11px" }}
                                      />
                                      <span
                                        style={{
                                          color: "var(--aggrid-text-color)",
                                          marginLeft: "5px",
                                          marginTop: "5px",
                                          fontSize: "11px",
                                        }}
                                      >
                                        Minutes
                                      </span>
                                    </Form.Group>
                                  </Col>
                                </Row>
                                <h5
                                  style={{
                                    color: "var(--aggrid-text-color)",
                                    marginTop: "10px",
                                    fontSize: "12px",
                                    fontWeight: "600",
                                  }}
                                >
                                  OUTPUT SETTINGS
                                </h5>
                                <span
                                  style={{
                                    color: "var(--aggrid-text-color)",
                                    fontSize: "11px",
                                  }}
                                >
                                  (Other Systems to DocDistro)
                                </span>
                                <Row md={12}>
                                  <Col md={3}>
                                    <Form.Group
                                      controlId="formGroupName"
                                      style={{
                                        display: "inline-block",
                                        width: "100%",
                                        marginTop: "10px",
                                      }}
                                    >
                                      <Form.Label
                                        className="input-labels"
                                        style={{
                                          color: "var(--aggrid-text-color)",
                                          fontSize: "11px",
                                        }}
                                      >
                                        URL{" "}
                                        <span
                                          style={{
                                            color: "var(--aggrid-text-color)",
                                            fontSize: "11px",
                                          }}
                                          className="required"
                                        >
                                          *
                                        </span>
                                      </Form.Label>
                                      <Form.Control
                                        type="text"
                                        placeholder="Enter the Url"
                                        name={`callBackUrl${subSourceChildindex}`}
                                        value={subSystemModelobj.aPICallbackUrl}
                                        onChange={(event) =>
                                          handleCallBackUrlChange(
                                            index,
                                            subSourceChildindex,
                                            event
                                          )
                                        }
                                        style={{ fontSize: "11px" }}
                                      />
                                    </Form.Group>
                                    {subSystemModelobj.errorApiallBackUrl && (
                                      <span
                                        style={{
                                          color: "red",
                                          marginLeft: "0px",
                                        }}
                                      >
                                        {subSystemModelobj.errorApiallBackUrl}
                                      </span>
                                    )}
                                  </Col>
                                  <Col md={3}>
                                    <Form.Group
                                      controlId="formGroupName"
                                      style={{
                                        display: "inline-block",
                                        width: "100%",
                                        marginTop: "10px",
                                      }}
                                    >
                                      <Form.Label
                                        className="input-labels"
                                        style={{
                                          color: "var(--aggrid-text-color)",
                                          fontSize: "11px",
                                        }}
                                      >
                                        User ID{" "}
                                        <span
                                          style={{
                                            color: "var(--aggrid-text-color)",
                                            fontSize: "11px",
                                          }}
                                          className="required"
                                        >
                                          *
                                        </span>
                                      </Form.Label>
                                      <Form.Control
                                        type="text"
                                        placeholder="Enter the User ID"
                                        name={`callBackUserId${subSourceChildindex}`}
                                        value={
                                          subSystemModelobj.aPICallback_UserName
                                        }
                                        onChange={(event) =>
                                          handleCallBackUserIdChange(
                                            index,
                                            subSourceChildindex,
                                            event
                                          )
                                        }
                                        style={{ fontSize: "11px" }}
                                      />
                                    </Form.Group>
                                    {subSystemModelobj.errorApiallBackUserId && (
                                      <span
                                        style={{
                                          color: "red",
                                          marginLeft: "0px",
                                        }}
                                      >
                                        {
                                          subSystemModelobj.errorApiallBackUserId
                                        }
                                      </span>
                                    )}
                                  </Col>
                                  <Col md={3}>
                                    <Form.Group
                                      controlId="formGroupName"
                                      style={{
                                        display: "inline-block",
                                        width: "100%",
                                        marginTop: "10px",
                                        fontSize: "11px",
                                      }}
                                    >
                                      <Form.Label
                                        className="input-labels"
                                        style={{
                                          color: "var(--aggrid-text-color)",
                                        }}
                                      >
                                        Password{" "}
                                        <span
                                          style={{
                                            color: "var(--aggrid-text-color)",
                                          }}
                                          className="required"
                                        >
                                          *
                                        </span>
                                      </Form.Label>
                                      <Form.Control
                                        type="password"
                                        placeholder="Enter the password"
                                        name={`callBackPassword${subSourceChildindex}`}
                                        value={
                                          subSystemModelobj.aPICallbackPassword
                                        }
                                        onChange={(event) =>
                                          handleCallBackPasswordChange(
                                            index,
                                            subSourceChildindex,
                                            event
                                          )
                                        }
                                        style={{ fontSize: "11px" }}
                                      />
                                    </Form.Group>
                                    {subSystemModelobj.errorApiallBackPassword && (
                                      <span
                                        style={{
                                          color: "red",
                                          marginLeft: "0px",
                                        }}
                                      >
                                        {
                                          subSystemModelobj.errorApiallBackPassword
                                        }
                                      </span>
                                    )}
                                  </Col>
                                  <Col md={3}>
                                    <Form.Group
                                      controlId="formGroupName"
                                      style={{
                                        display: "inline-block",
                                        width: "100%",
                                        marginTop: "10px",
                                        fontSize: "11px",
                                      }}
                                    >
                                      <Form.Label
                                        className="input-labels"
                                        style={{
                                          color: "var(--aggrid-text-color)",
                                        }}
                                      >
                                        Level 1
                                      </Form.Label>
                                      <Form.Select
                                        name={`level1${subSourceChildindex}`}
                                        value={subSystemModelobj.fromLevel1}
                                        onChange={(e) =>
                                          handleLevel1Change(
                                            index,
                                            subSourceChildindex,
                                            e
                                          )
                                        }
                                        style={{ fontSize: "11px" }}
                                      >
                                        <option value="0">Select</option>
                                        {level.map((level: any) => (
                                          <option
                                            key={level.fundFolderId}
                                            value={level.fundFolderId}
                                          >
                                            {level.folderName}
                                          </option>
                                        ))}
                                      </Form.Select>
                                    </Form.Group>
                                  </Col>
                                </Row>
                                <Row md={12}>
                                  <Col md={3}>
                                    <Form.Group
                                      controlId="formGroupName"
                                      style={{
                                        display: "inline-block",
                                        width: "100%",
                                        marginTop: "10px",
                                      }}
                                    >
                                      <Form.Label
                                        className="input-labels"
                                        style={{
                                          color: "var(--aggrid-text-color)",
                                          fontSize: "11px",
                                        }}
                                      >
                                        Error Mail
                                      </Form.Label>
                                      <Form.Control
                                        type="text"
                                        placeholder="Enter the preflight error email"
                                        name={`errorMail_${subSourceChildindex}`}
                                        value={
                                          subSystemModelobj.preflightErroremail
                                        }
                                        onChange={(event) =>
                                          handleErrorMailChange(
                                            index,
                                            subSourceChildindex,
                                            event
                                          )
                                        }
                                        style={{ fontSize: "11px" }}
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col
                                    md={1}
                                    style={{
                                      marginTop: "25px",
                                      color: "var(--aggrid-text-color)",
                                      fontSize: "11px",
                                    }}
                                  >
                                    Import
                                    <Form.Check
                                      type="checkbox"
                                      name={`isFromHeader_${subSourceChildindex}`}
                                      value={subSystemModelobj.isImportActive}
                                      style={{ marginTop: "10px" }}
                                      checked={subSystemModelobj.isImportActive}
                                      onChange={(event) =>
                                        handleImportChange(
                                          index,
                                          subSourceChildindex,
                                          event
                                        )
                                      }
                                    />
                                  </Col>
                                  <Col
                                    md={2}
                                    style={{
                                      marginTop: "25px",
                                      color: "var(--aggrid-text-color)",
                                      fontSize: "11px",
                                    }}
                                  >
                                    Allow Reprocess
                                    <Form.Check
                                      type="checkbox"
                                      name={`allowReprocess_${subSourceChildindex}`}
                                      value={subSystemModelobj.isAllowReprocess}
                                      style={{ marginTop: "10px" }}
                                      checked={
                                        subSystemModelobj.isAllowReprocess
                                      }
                                      onChange={(event) =>
                                        handleAllowReprocessChange(
                                          index,
                                          subSourceChildindex,
                                          event
                                        )
                                      }
                                    />
                                  </Col>
                                </Row>
                              </>
                            )}

                            {subSystemModelobj.aPI_SMB === 2 && (
                              <>
                                <h5
                                  style={{
                                    color: "var(--aggrid-text-color)",
                                    marginTop: "10px",
                                  }}
                                >
                                  INPUT SETTINGS
                                </h5>
                                <span
                                  style={{ color: "var(--aggrid-text-color)" }}
                                >
                                  (DocDistro to Other Systems)
                                </span>
                                <Row md={12}>
                                  <Col md={3} style={{ marginBottom: "10px" }}>
                                    <Form.Group controlId="formCustomer">
                                      <Form.Label
                                        className="input-labels"
                                        style={{
                                          color: "var(--aggrid-text-color)",
                                          fontSize: "11px",
                                        }}
                                      >
                                        Input Options
                                        <span
                                          style={{
                                            color: "var(--aggrid-text-color)",
                                          }}
                                          className="required"
                                        >
                                          *
                                        </span>
                                      </Form.Label>
                                      <Form.Select
                                        name={`inputOptions_${subSourceChildindex}`}
                                        value={subSystemModelobj.tolocationType}
                                        onChange={(event) =>
                                          handleInputOptionChange(
                                            index,
                                            subSourceChildindex,
                                            event
                                          )
                                        }
                                        style={{ fontSize: "11px" }}
                                      >
                                        <option value="0">Select</option>
                                        {inputSourceTypes.map(
                                          (sourceType: any) => (
                                            <option
                                              key={sourceType.id}
                                              value={sourceType.id}
                                            >
                                              {sourceType.name}
                                            </option>
                                          )
                                        )}
                                      </Form.Select>
                                      {subSystemModelobj.errorToLocationType && (
                                        <span
                                          style={{
                                            color: "red",
                                            marginLeft: "0px",
                                          }}
                                        >
                                          {
                                            subSystemModelobj.errorToLocationType
                                          }
                                        </span>
                                      )}
                                    </Form.Group>
                                  </Col>
                                  {allSystemConfig.isPdfSelected && (
                                    <Col
                                      md={3}
                                      style={{ marginBottom: "10px" }}
                                    >
                                      <Form.Group controlId="formCustomer">
                                        <Form.Label
                                          className="input-labels"
                                          style={{
                                            color: "var(--aggrid-text-color)",
                                            fontSize: "11px",
                                          }}
                                        >
                                          To Source Location 1
                                        </Form.Label>
                                        <Form.Select
                                          name={`toSourceLocation_${subSourceChildindex}`}
                                          value={
                                            subSystemModelobj.toPdfLocationId
                                          }
                                          style={{ fontSize: "11px" }}
                                          onChange={(event) =>
                                            handleToSourceLocationChange(
                                              index,
                                              subSourceChildindex,
                                              event
                                            )
                                          }
                                        >
                                          <option value="">Select</option>
                                          {activeFileLocations.map(
                                            (activeFileLocation: any) => (
                                              <option
                                                key={
                                                  activeFileLocation.ftpFolderId
                                                }
                                                value={
                                                  activeFileLocation.ftpFolderId
                                                }
                                              >
                                                {activeFileLocation.folderName}
                                              </option>
                                            )
                                          )}
                                        </Form.Select>
                                      </Form.Group>
                                    </Col>
                                  )}
                                  {allSystemConfig.isMetadataSelected && (
                                    <>
                                      <Col
                                        md={3}
                                        style={{ marginBottom: "10px" }}
                                      >
                                        <Form.Group controlId="formCustomer">
                                          <Form.Label
                                            className="input-labels"
                                            style={{
                                              color: "var(--aggrid-text-color)",
                                              fontSize: "11px",
                                            }}
                                          >
                                            To Metadata Source Location
                                          </Form.Label>
                                          <Form.Select
                                            name={`toMetadataSource_${subSourceChildindex}`}
                                            value={
                                              subSystemModelobj.toMetadataLocationId
                                            }
                                            onChange={(event) =>
                                              handleToMetadataSourceChange(
                                                index,
                                                subSourceChildindex,
                                                event
                                              )
                                            }
                                            style={{ fontSize: "11px" }}
                                          >
                                            <option value="0">Select</option>
                                            {activeFileLocations.map(
                                              (activeFileLocation: any) => (
                                                <option
                                                  key={
                                                    activeFileLocation.ftpFolderId
                                                  }
                                                  value={
                                                    activeFileLocation.ftpFolderId
                                                  }
                                                >
                                                  {
                                                    activeFileLocation.folderName
                                                  }
                                                </option>
                                              )
                                            )}
                                          </Form.Select>
                                        </Form.Group>
                                      </Col>
                                      <Col
                                        md={3}
                                        style={{ marginBottom: "10px" }}
                                      >
                                        <Form.Group controlId="formCustomer">
                                          <Form.Label
                                            className="input-labels"
                                            style={{
                                              color: "var(--aggrid-text-color)",
                                              fontSize: "11px",
                                            }}
                                          >
                                            To Metadata Definition
                                          </Form.Label>
                                          <Form.Select
                                            name={`toMetadataDefination_${subSourceChildindex}`}
                                            value={
                                              subSystemModelobj.toSourceMetadataDefinitionId
                                            }
                                            onChange={(event) =>
                                              handleToMetadataDefinationChange(
                                                index,
                                                subSourceChildindex,
                                                event
                                              )
                                            }
                                            style={{ fontSize: "11px" }}
                                          >
                                            <option value="0">Select</option>
                                            {metadataColumns.map(
                                              (metadataColumn: any) => (
                                                <option
                                                  key={
                                                    metadataColumn.metadataDefinitionId
                                                  }
                                                  value={
                                                    metadataColumn.metadataDefinitionId
                                                  }
                                                >
                                                  {
                                                    metadataColumn.metadataDefinitionName
                                                  }
                                                </option>
                                              )
                                            )}
                                          </Form.Select>
                                        </Form.Group>
                                      </Col>
                                      <Col
                                        style={{
                                          width: "125px",
                                          color: "var(--aggrid-text-color)",
                                          marginBottom: "10px",
                                          fontSize: "11px",
                                        }}
                                      >
                                        <span
                                          style={{
                                            color: "var(--aggrid-text-color)",
                                            marginTop: "10px",
                                            fontSize: "11px",
                                          }}
                                        >
                                          Header
                                        </span>
                                        <span
                                          style={{
                                            display: "flex",
                                            marginTop: "10px",
                                          }}
                                        >
                                          <Form.Check
                                            type="radio"
                                            name={`header_${subSourceChildindex}`}
                                            value="1"
                                            label="Yes"
                                            checked={
                                              subSystemModelobj.isToSourceHeaderAvailable ===
                                              1
                                            }
                                            onChange={(event) =>
                                              handleHeaderChange(
                                                index,
                                                subSourceChildindex,
                                                event
                                              )
                                            }
                                          />
                                          <Form.Check
                                            type="radio"
                                            name={`header_${subSourceChildindex}`}
                                            value="2"
                                            label="No"
                                            style={{ marginLeft: "8px" }}
                                            checked={
                                              subSystemModelobj.isToSourceHeaderAvailable ===
                                              2
                                            }
                                            onChange={(event) =>
                                              handleHeaderChange(
                                                index,
                                                subSourceChildindex,
                                                event
                                              )
                                            }
                                          />
                                        </span>
                                      </Col>
                                    </>
                                  )}
                                  {allSystemConfig.isPdfSelected && (
                                    <Col
                                      md={3}
                                      style={{
                                        color: "var(--aggrid-text-color)",
                                        marginBottom: "10px",
                                        wordWrap: "break-word",
                                        fontSize: "11px",
                                      }}
                                    >
                                      <span
                                        style={{
                                          width: "50%",
                                          display: "block",
                                        }}
                                      >
                                        {" "}
                                        To Source Location 1 Path
                                      </span>
                                      <span>
                                        {subSystemModelobj.toPdfLocationPath}
                                      </span>
                                    </Col>
                                  )}
                                  {allSystemConfig.isMetadataSelected && (
                                    <Col
                                      md={3}
                                      style={{
                                        color: "var(--aggrid-text-color)",
                                        marginBottom: "10px",
                                        wordWrap: "break-word",
                                        fontSize: "11px",
                                      }}
                                    >
                                      <span
                                        style={{
                                          width: "65%",
                                          display: "block",
                                        }}
                                      >
                                        {" "}
                                        To Metadata Source Location Path
                                      </span>
                                      <span>
                                        {
                                          subSystemModelobj.toMetadataLocationPath
                                        }
                                      </span>
                                    </Col>
                                  )}
                                  {allSystemConfig.isPdfSelected && (
                                    <Col
                                      md={3}
                                      style={{ marginBottom: "10px" }}
                                    >
                                      <Form.Group controlId="formCustomer">
                                        <Form.Label
                                          className="input-labels"
                                          style={{
                                            color: "var(--aggrid-text-color)",
                                            fontSize: "11px",
                                          }}
                                        >
                                          PDF Naming Nomenclature
                                        </Form.Label>
                                        <Form.Control
                                          type="text"
                                          name={`pdfNamingNome${subSourceChildindex}`}
                                          value={
                                            subSystemModelobj.pdfNamingConvention
                                          }
                                          onChange={(event) =>
                                            handlePdfNamingNomChange(
                                              index,
                                              subSourceChildindex,
                                              event
                                            )
                                          }
                                          style={{ fontSize: "11px" }}
                                        ></Form.Control>
                                      </Form.Group>
                                    </Col>
                                  )}
                                  {allSystemConfig.isMetadataSelected && (
                                    <Col
                                      md={3}
                                      style={{
                                        marginBottom: "10px",
                                        fontSize: "11px",
                                      }}
                                    >
                                      <Form.Group
                                        controlId="formCustomer"
                                        style={{ display: "ruby" }}
                                      >
                                        <Form.Label
                                          className="input-labels"
                                          style={{
                                            color: "var(--aggrid-text-color)",
                                          }}
                                        >
                                          Metadata Naming Nomenclature
                                        </Form.Label>
                                        <Form.Control
                                          type="text"
                                          name={`metadataNaming_${subSourceChildindex}`}
                                          value={
                                            subSystemModelobj.metadataNamingConvention
                                          }
                                          onChange={(event) =>
                                            handleMetadataNamingChange(
                                              index,
                                              subSourceChildindex,
                                              event
                                            )
                                          }
                                          style={{
                                            width: "93%",
                                            fontSize: "11px",
                                          }}
                                        ></Form.Control>
                                        <Tooltip
                                          title="Ex : Text_{File name}_{Action code}, Date format - {yyyymmddhhmmssfff}, Sequence number format - {Sequence}"
                                          arrow
                                        >
                                          <PermDeviceInformationRoundedIcon
                                            style={{
                                              color: "var(--aggrid-text-color)",
                                              alignItems: "center",
                                            }}
                                          />
                                        </Tooltip>
                                      </Form.Group>
                                    </Col>
                                  )}
                                  <Col
                                    md={3}
                                    style={{
                                      color: "var(--aggrid-text-color)",
                                      marginBottom: "10px",
                                      fontSize: "11px",
                                    }}
                                  >
                                    Export
                                    <Form.Check
                                      type="checkbox"
                                      name="export"
                                      style={{ marginTop: "10px" }}
                                      checked={subSystemModelobj.isExportActive}
                                      value={subSystemModelobj.isExportActive}
                                      onChange={(event) =>
                                        handleExportChange(
                                          index,
                                          subSourceChildindex,
                                          event
                                        )
                                      }
                                    />
                                  </Col>
                                  <Col
                                    style={{
                                      width: "125px",
                                      color: "var(--aggrid-text-color)",
                                      marginBottom: "10px",
                                      fontSize: "11px",
                                    }}
                                  >
                                    <span
                                      style={{
                                        color: "var(--aggrid-text-color)",
                                        marginTop: "10px",
                                      }}
                                    >
                                      Export Option
                                    </span>
                                    <span
                                      style={{
                                        display: "flex",
                                        marginTop: "10px",
                                      }}
                                    >
                                      <Form.Check
                                        type="radio"
                                        name="exportOption"
                                        value="1"
                                        label="Single"
                                        checked={
                                          subSystemModelobj.exportOption === 1
                                        }
                                        onChange={(event) =>
                                          handleExportOptionChange(
                                            index,
                                            subSourceChildindex,
                                            event
                                          )
                                        }
                                      />
                                      <Form.Check
                                        type="radio"
                                        name="exportOption"
                                        value="2"
                                        label="Merge"
                                        style={{ marginLeft: "8px" }}
                                        checked={
                                          subSystemModelobj.exportOption === 2
                                        }
                                        onChange={(event) =>
                                          handleExportOptionChange(
                                            index,
                                            subSourceChildindex,
                                            event
                                          )
                                        }
                                      />
                                    </span>
                                  </Col>
                                </Row>
                                <span
                                  style={{
                                    color: "var(--aggrid-text-color)",
                                    marginTop: "10px",
                                    fontSize: "11px",
                                  }}
                                >
                                  Set Communication Frequency :
                                </span>
                                <Row>
                                  <Col md={1}>
                                    <Form.Group
                                      controlId="formGroupName"
                                      style={{
                                        width: "120%",
                                        marginTop: "10px",
                                        display: "flex",
                                      }}
                                    >
                                      <Form.Control
                                        type="number"
                                        placeholder="0"
                                        name={`hours_${subSourceChildindex}`}
                                        value={subSystemModelobj.frequencyHrs}
                                        onChange={(event) =>
                                          handleHoursChange(
                                            index,
                                            subSourceChildindex,
                                            event
                                          )
                                        }
                                        min="0"
                                        style={{ fontSize: "11px" }}
                                      />
                                      <span
                                        style={{
                                          color: "var(--aggrid-text-color)",
                                          marginLeft: "5px",
                                          marginTop: "5px",
                                          fontSize: "11px",
                                        }}
                                      >
                                        Hour
                                      </span>
                                    </Form.Group>
                                  </Col>
                                  <Col md={1}>
                                    <Form.Group
                                      controlId="formGroupName"
                                      style={{
                                        width: "140%",
                                        marginLeft: "10px",
                                        marginTop: "10px",
                                        display: "flex",
                                      }}
                                    >
                                      <Form.Control
                                        type="number"
                                        placeholder="0"
                                        name={`minutes_${subSourceChildindex}`}
                                        value={subSystemModelobj.frequencyMins}
                                        onChange={(event) =>
                                          handleMinutesChange(
                                            index,
                                            subSourceChildindex,
                                            event
                                          )
                                        }
                                        min="0"
                                        style={{ fontSize: "11px" }}
                                      />
                                      <span
                                        style={{
                                          color: "var(--aggrid-text-color)",
                                          marginLeft: "5px",
                                          marginTop: "5px",
                                          fontSize: "11px",
                                        }}
                                      >
                                        Minutes
                                      </span>
                                    </Form.Group>
                                  </Col>
                                </Row>
                                <h5
                                  style={{
                                    color: "var(--aggrid-text-color)",
                                    marginTop: "10px",
                                    fontSize: "12px",
                                    fontWeight: "600",
                                  }}
                                >
                                  OUTPUT SETTINGS
                                </h5>
                                <span
                                  style={{ color: "var(--aggrid-text-color)" }}
                                >
                                  (Other Systems to DocDistro)
                                </span>
                                <Row md={12}>
                                  <Col md={3} style={{ marginBottom: "10px" }}>
                                    <Form.Group controlId="formCustomer">
                                      <Form.Label
                                        className="input-labels"
                                        style={{
                                          color: "var(--aggrid-text-color)",
                                          fontSize: "11px",
                                        }}
                                      >
                                        Output Options
                                      </Form.Label>
                                      <Form.Select
                                        name={`outputOption_${subSourceChildindex}`}
                                        value={subSystemModelobj.fromType}
                                        onChange={(event) =>
                                          handleOutputOptionChange(
                                            index,
                                            subSourceChildindex,
                                            event
                                          )
                                        }
                                        style={{ fontSize: "11px" }}
                                      >
                                        <option value="0">Select</option>
                                        {outputSourceTypes.map(
                                          (sourceType: any) => (
                                            <option
                                              key={sourceType.id}
                                              value={sourceType.id}
                                            >
                                              {sourceType.name}
                                            </option>
                                          )
                                        )}
                                      </Form.Select>
                                    </Form.Group>
                                  </Col>
                                  {allSystemConfig.isOutputPdfSelected && (
                                    <Col
                                      md={3}
                                      style={{ marginBottom: "10px" }}
                                    >
                                      <Form.Group controlId="formCustomer">
                                        <Form.Label
                                          className="input-labels"
                                          style={{
                                            color: "var(--aggrid-text-color)",
                                            fontSize: "11px",
                                          }}
                                        >
                                          From Source Location
                                        </Form.Label>
                                        <Form.Select
                                          name={`fromSourceLocation_${subSourceChildindex}`}
                                          value={
                                            subSystemModelobj.fromLocationId
                                          }
                                          onChange={(event) =>
                                            handleFromSourceLocationChange(
                                              index,
                                              subSourceChildindex,
                                              event
                                            )
                                          }
                                          style={{ fontSize: "11px" }}
                                        >
                                          <option value="0">Select</option>
                                          {activeFileLocations.map(
                                            (activeFileLocation: any) => (
                                              <option
                                                key={
                                                  activeFileLocation.ftpFolderId
                                                }
                                                value={
                                                  activeFileLocation.ftpFolderId
                                                }
                                              >
                                                {activeFileLocation.folderName}
                                              </option>
                                            )
                                          )}
                                        </Form.Select>
                                      </Form.Group>
                                    </Col>
                                  )}
                                  {allSystemConfig.isOutputMetadataSelected && (
                                    <>
                                      <Col
                                        md={3}
                                        style={{
                                          marginBottom: "10px",
                                          fontSize: "11px",
                                        }}
                                      >
                                        <Form.Group controlId="formCustomer">
                                          <Form.Label
                                            className="input-labels"
                                            style={{
                                              color: "var(--aggrid-text-color)",
                                            }}
                                          >
                                            From Metadata Location
                                          </Form.Label>
                                          <Form.Select
                                            name={`fromMetadataLocation_${subSourceChildindex}`}
                                            value={
                                              subSystemModelobj.fromMetaDataLocationId
                                            }
                                            onChange={(event) =>
                                              handleFromMetadataLocationChange(
                                                index,
                                                subSourceChildindex,
                                                event
                                              )
                                            }
                                            style={{ fontSize: "11px" }}
                                          >
                                            <option value="0">Select</option>
                                            {activeFileLocations.map(
                                              (activeFileLocation: any) => (
                                                <option
                                                  key={
                                                    activeFileLocation.ftpFolderId
                                                  }
                                                  value={
                                                    activeFileLocation.ftpFolderId
                                                  }
                                                >
                                                  {
                                                    activeFileLocation.folderName
                                                  }
                                                </option>
                                              )
                                            )}
                                          </Form.Select>
                                        </Form.Group>
                                      </Col>
                                      <Col
                                        md={3}
                                        style={{ marginBottom: "10px" }}
                                      >
                                        <Form.Group controlId="formCustomer">
                                          <Form.Label
                                            className="input-labels"
                                            style={{
                                              color: "var(--aggrid-text-color)",
                                              fontSize: "11px",
                                            }}
                                          >
                                            From Metadata Definition
                                          </Form.Label>
                                          <Form.Select
                                            name={`fromMetadataDefination_${subSourceChildindex}`}
                                            value={
                                              subSystemModelobj.fromSourceMetadataDefinitionId
                                            }
                                            onChange={(event) =>
                                              handleFromMetadataDefinationChange(
                                                index,
                                                subSourceChildindex,
                                                event
                                              )
                                            }
                                            style={{ fontSize: "11px" }}
                                          >
                                            <option value="0">Select</option>
                                            {metadataColumns.map(
                                              (metadataColumn: any) => (
                                                <option
                                                  key={
                                                    metadataColumn.metadataDefinitionId
                                                  }
                                                  value={
                                                    metadataColumn.metadataDefinitionId
                                                  }
                                                >
                                                  {
                                                    metadataColumn.metadataDefinitionName
                                                  }
                                                </option>
                                              )
                                            )}
                                          </Form.Select>
                                        </Form.Group>
                                      </Col>
                                      <Col
                                        md={3}
                                        style={{
                                          color: "var(--aggrid-text-color)",
                                          marginBottom: "10px",
                                          fontSize: "11px",
                                        }}
                                      >
                                        <span
                                          style={{
                                            color: "var(--aggrid-text-color)",
                                            marginTop: "10px",
                                          }}
                                        >
                                          Header
                                        </span>
                                        <span
                                          style={{
                                            display: "flex",
                                            marginTop: "10px",
                                          }}
                                        >
                                          <Form.Check
                                            type="radio"
                                            name={`header_${subSourceChildindex}`}
                                            value="1"
                                            label="Yes"
                                            checked={
                                              subSystemModelobj.isFromSourceHeaderAvailable ===
                                              1
                                            }
                                            onChange={(event) =>
                                              handleHeaderChange(
                                                index,
                                                subSourceChildindex,
                                                event
                                              )
                                            }
                                          />
                                          <Form.Check
                                            type="radio"
                                            name={`header_${subSourceChildindex}`}
                                            value="2"
                                            label="No"
                                            style={{ marginLeft: "8px" }}
                                            checked={
                                              subSystemModelobj.isFromSourceHeaderAvailable ===
                                              2
                                            }
                                            onChange={(event) =>
                                              handleHeaderChange(
                                                index,
                                                subSourceChildindex,
                                                event
                                              )
                                            }
                                          />
                                        </span>
                                      </Col>
                                    </>
                                  )}
                                  {allSystemConfig.isOutputPdfSelected && (
                                    <Col
                                      md={3}
                                      style={{
                                        color: "var(--aggrid-text-color)",
                                        marginBottom: "10px",
                                        wordWrap: "break-word",
                                        fontSize: "11px",
                                      }}
                                    >
                                      <span
                                        style={{
                                          width: "50%",
                                          display: "block",
                                        }}
                                      >
                                        {" "}
                                        From Source Location Path
                                      </span>
                                      <span style={{ marginBottom: "10px" }}>
                                        {subSystemModelobj.fromLocationPath}
                                      </span>
                                    </Col>
                                  )}
                                  {allSystemConfig.isOutputMetadataSelected && (
                                    <Col
                                      md={3}
                                      style={{
                                        color: "var(--aggrid-text-color)",
                                        marginBottom: "10px",
                                        wordWrap: "break-word",
                                      }}
                                    >
                                      <span
                                        style={{
                                          width: "50%",
                                          display: "block",
                                        }}
                                      >
                                        {" "}
                                        From Metadata Location Path
                                      </span>
                                      <span>
                                        {
                                          subSystemModelobj.fromMetadataLocationPath
                                        }
                                      </span>
                                    </Col>
                                  )}
                                  <Col md={3} style={{ marginBottom: "10px" }}>
                                    <Form.Group controlId="formCustomer">
                                      <Form.Label
                                        className="input-labels"
                                        style={{
                                          color: "var(--aggrid-text-color)",
                                          fontSize: "11px",
                                        }}
                                      >
                                        Level 1
                                      </Form.Label>
                                      <Form.Select
                                        name={`level1_${subSourceChildindex}`}
                                        value={subSystemModelobj.fromLevel1}
                                        onChange={(event) =>
                                          handleLevel1Change(
                                            index,
                                            subSourceChildindex,
                                            event
                                          )
                                        }
                                        style={{ fontSize: "11px" }}
                                      >
                                        <option value="0">Select</option>
                                        {level.map((level: any) => (
                                          <option
                                            key={level.fundFolderId}
                                            value={level.fundFolderId}
                                          >
                                            {level.folderName}
                                          </option>
                                        ))}
                                      </Form.Select>
                                    </Form.Group>
                                  </Col>
                                  <Col
                                    md={1}
                                    style={{
                                      color: "var(--aggrid-text-color)",
                                      fontSize: "11px",
                                    }}
                                  >
                                    Import
                                    <Form.Check
                                      type="checkbox"
                                      name="import"
                                      value={subSystemModelobj.isImportActive}
                                      checked={subSystemModelobj.isImportActive}
                                      style={{
                                        marginTop: "10px",
                                        fontSize: "11px",
                                      }}
                                      onChange={(event) =>
                                        handleImportChange(
                                          index,
                                          subSourceChildindex,
                                          event
                                        )
                                      }
                                    />
                                  </Col>
                                  <Col
                                    md={2}
                                    style={{
                                      color: "var(--aggrid-text-color)",
                                      fontSize: "11px",
                                    }}
                                  >
                                    Allow Reprocess
                                    <Form.Check
                                      type="checkbox"
                                      name="allowReprocess"
                                      value={subSystemModelobj.isAllowReprocess}
                                      checked={
                                        subSystemModelobj.isAllowReprocess
                                      }
                                      style={{
                                        marginTop: "10px",
                                        fontSize: "11px",
                                      }}
                                      onChange={(event) =>
                                        handleAllowReprocessChange(
                                          index,
                                          subSourceChildindex,
                                          event
                                        )
                                      }
                                    />
                                  </Col>
                                </Row>
                              </>
                            )}
                          </>
                        )
                      )}
                    </form>
                  )}
                </>
              ))}
            </div>
          )}
          {nextStep !== 0 && (
            <Button
              variant="outlined"
              type="button"
              onClick={handleBack}
              color="primary"
              className={styles.btnClass}
              style={{
                backgroundColor: "var(--button-background-color)",
                color: "var(--button-color)",
                fontSize: "11px",
                borderRadius: "4px",
                border: "1px solid #858c94",
                height: "25px",
              }}
            >
              Previous
            </Button>
          )}
          {nextStep === 0 || nextStep < steps.length - 1 ? (
            <Button
              variant="outlined"
              type="button"
              onClick={handleNextSubmit}
              color="primary"
              className={styles.btnClass}
            >
              Next
            </Button>
          ) : (
            <Button
              variant="outlined"
              type="button"
              onClick={handleSubmit}
              color="primary"
              className={styles.btnClass}
            >
              Submit
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubSystemConfiguration;
